/* tslint:disable */
/* eslint-disable */
/**
 * Eigenwijs v2 Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base";

/**
 *
 * @export
 * @interface Address
 */
export interface Address {
  /**
   *
   * @type {string}
   * @memberof Address
   */
  emailAddress: string;
  /**
   *
   * @type {ShippingAddress}
   * @memberof Address
   */
  shippingAddress: ShippingAddress;
  /**
   *
   * @type {InvoiceAddress}
   * @memberof Address
   */
  invoiceAddress: InvoiceAddress;
}
/**
 *
 * @export
 * @interface AttachmentImage
 */
export interface AttachmentImage {
  /**
   *
   * @type {string}
   * @memberof AttachmentImage
   */
  dimensions?: string;
  /**
   *
   * @type {string}
   * @memberof AttachmentImage
   */
  mimetype?: string;
  /**
   *
   * @type {string}
   * @memberof AttachmentImage
   */
  url?: string;
}
/**
 *
 * @export
 * @interface AvailableBumbalDate
 */
export interface AvailableBumbalDate {
  /**
   *
   * @type {string}
   * @memberof AvailableBumbalDate
   */
  dateFrom: string;
  /**
   *
   * @type {string}
   * @memberof AvailableBumbalDate
   */
  dateTo: string;
  /**
   *
   * @type {number}
   * @memberof AvailableBumbalDate
   */
  price: number;
}
/**
 *
 * @export
 * @interface CategoryStandardProduct
 */
export interface CategoryStandardProduct {
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof CategoryStandardProduct
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof CategoryStandardProduct
   */
  amount: number;
  /**
   *
   * @type {boolean}
   * @memberof CategoryStandardProduct
   */
  disabled: boolean;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  sampleProductCode: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  exactArticleCode: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  imageId: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  mainImageAltText: string;
  /**
   *
   * @type {CategoryStandardProductDeliveryMethod}
   * @memberof CategoryStandardProduct
   */
  deliveryMethod: CategoryStandardProductDeliveryMethod;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof CategoryStandardProduct
   */
  inStore: boolean;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  productTypeId: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  thumbnailId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CategoryStandardProduct
   */
  images: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  shortname: string;
  /**
   *
   * @type {CategoryStandardProductProductType}
   * @memberof CategoryStandardProduct
   */
  productType: CategoryStandardProductProductType;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  dateModified: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  userIdCreated: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProduct
   */
  userIdModified: string;
  /**
   *
   * @type {Array<StandardProductWarehouse>}
   * @memberof CategoryStandardProduct
   */
  exactArticleWarehouseLocation: Array<StandardProductWarehouse>;
  /**
   *
   * @type {Array<StandardProductDeliveryCondition>}
   * @memberof CategoryStandardProduct
   */
  deliveryCondition: Array<StandardProductDeliveryCondition>;
  /**
   *
   * @type {number}
   * @memberof CategoryStandardProduct
   */
  sortOrder: number;
}
/**
 *
 * @export
 * @interface CategoryStandardProductDeliveryMethod
 */
export interface CategoryStandardProductDeliveryMethod {
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  prio: number;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  exactArticleCode: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductDeliveryMethod
   */
  dateModified: string;
}
/**
 *
 * @export
 * @interface CategoryStandardProductProductType
 */
export interface CategoryStandardProductProductType {
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductProductType
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductProductType
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductProductType
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductProductType
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductProductType
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof CategoryStandardProductProductType
   */
  dateModified: string;
}
/**
 *
 * @export
 * @interface CheckSaleLocationResponse
 */
export interface CheckSaleLocationResponse {
  /**
   *
   * @type {boolean}
   * @memberof CheckSaleLocationResponse
   */
  isSaleLocation: boolean;
}
/**
 *
 * @export
 * @interface CheckoutPayload
 */
export interface CheckoutPayload {
  /**
   *
   * @type {string}
   * @memberof CheckoutPayload
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CheckoutPayload
   */
  emailAddress: string;
  /**
   *
   * @type {Address}
   * @memberof CheckoutPayload
   */
  address: Address;
  /**
   *
   * @type {boolean}
   * @memberof CheckoutPayload
   */
  addressValid: boolean;
  /**
   *
   * @type {string}
   * @memberof CheckoutPayload
   */
  discountCode: string;
  /**
   *
   * @type {Array<SupplyProduct>}
   * @memberof CheckoutPayload
   */
  supplyProducts: Array<SupplyProduct>;
  /**
   *
   * @type {Array<Product>}
   * @memberof CheckoutPayload
   */
  products: Array<Product>;
  /**
   *
   * @type {Array<CategoryStandardProduct>}
   * @memberof CheckoutPayload
   */
  standardProducts: Array<CategoryStandardProduct>;
  /**
   *
   * @type {string}
   * @memberof CheckoutPayload
   */
  pickupWarehouse: string;
  /**
   *
   * @type {CheckoutPayloadStandardProductPayment}
   * @memberof CheckoutPayload
   */
  standardProductPayment: CheckoutPayloadStandardProductPayment;
  /**
   *
   * @type {string}
   * @memberof CheckoutPayload
   */
  saleLocation: string;
  /**
   *
   * @type {boolean}
   * @memberof CheckoutPayload
   */
  isSelfAssembly?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CheckoutPayload
   */
  withAssembly: boolean;
  /**
   *
   * @type {string}
   * @memberof CheckoutPayload
   */
  bumbalFlow?: string;
  /**
   *
   * @type {number}
   * @memberof CheckoutPayload
   */
  deliveryCosts?: number;
  /**
   *
   * @type {string}
   * @memberof CheckoutPayload
   */
  shoppingCartId: string;
  /**
   *
   * @type {number}
   * @memberof CheckoutPayload
   */
  totalPrice: number;
  /**
   *
   * @type {CreateCartPayloadPaymentMethod}
   * @memberof CheckoutPayload
   */
  paymentMethod: CreateCartPayloadPaymentMethod;
  /**
   *
   * @type {CreateCartPayloadDelivery}
   * @memberof CheckoutPayload
   */
  delivery: CreateCartPayloadDelivery;
  /**
   *
   * @type {boolean}
   * @memberof CheckoutPayload
   */
  subscribeToNewsletter: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CheckoutPayload
   */
  sampleSale: boolean;
  /**
   *
   * @type {WarrantyPackage}
   * @memberof CheckoutPayload
   */
  warrantyPackage?: WarrantyPackage;
  /**
   *
   * @type {Array<string>}
   * @memberof CheckoutPayload
   */
  internalNotes: Array<string>;
}
/**
 *
 * @export
 * @interface CheckoutPayloadStandardProductPayment
 */
export interface CheckoutPayloadStandardProductPayment {
  /**
   *
   * @type {string}
   * @memberof CheckoutPayloadStandardProductPayment
   */
  paymentType: string;
  /**
   *
   * @type {number}
   * @memberof CheckoutPayloadStandardProductPayment
   */
  paymentMethod: number;
  /**
   *
   * @type {number}
   * @memberof CheckoutPayloadStandardProductPayment
   */
  paymentBank: number;
}
/**
 *
 * @export
 * @interface CheckoutResponse
 */
export interface CheckoutResponse {
  /**
   *
   * @type {string}
   * @memberof CheckoutResponse
   */
  nextStep: string;
  /**
   *
   * @type {boolean}
   * @memberof CheckoutResponse
   */
  isSampleSale: boolean;
  /**
   *
   * @type {string}
   * @memberof CheckoutResponse
   */
  paymentUrl: string;
  /**
   *
   * @type {string}
   * @memberof CheckoutResponse
   */
  orderId: string;
}
/**
 *
 * @export
 * @interface CreateBumbalDatePayload
 */
export interface CreateBumbalDatePayload {
  /**
   *
   * @type {string}
   * @memberof CreateBumbalDatePayload
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof CreateBumbalDatePayload
   */
  dateFrom: string;
  /**
   *
   * @type {string}
   * @memberof CreateBumbalDatePayload
   */
  dateTo: string;
}
/**
 *
 * @export
 * @interface CreateCartPayload
 */
export interface CreateCartPayload {
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  emailAddress: string;
  /**
   *
   * @type {Address}
   * @memberof CreateCartPayload
   */
  address: Address;
  /**
   *
   * @type {boolean}
   * @memberof CreateCartPayload
   */
  addressValid: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  discountCode: string;
  /**
   *
   * @type {Array<SupplyProduct>}
   * @memberof CreateCartPayload
   */
  supplyProducts: Array<SupplyProduct>;
  /**
   *
   * @type {Array<Product>}
   * @memberof CreateCartPayload
   */
  products: Array<Product>;
  /**
   *
   * @type {Array<CategoryStandardProduct>}
   * @memberof CreateCartPayload
   */
  standardProducts: Array<CategoryStandardProduct>;
  /**
   *
   * @type {WarrantyPackage}
   * @memberof CreateCartPayload
   */
  warrantyPackage?: WarrantyPackage;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  saleLocation: string;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  pickupWarehouse: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateCartPayload
   */
  isSelfAssembly?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  bumbalFlow?: string;
  /**
   *
   * @type {number}
   * @memberof CreateCartPayload
   */
  deliveryCosts?: number;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  shoppingCartId: string;
  /**
   *
   * @type {number}
   * @memberof CreateCartPayload
   */
  totalPrice: number;
  /**
   *
   * @type {CreateCartPayloadStandardProductPayment}
   * @memberof CreateCartPayload
   */
  standardProductPayment: CreateCartPayloadStandardProductPayment;
  /**
   *
   * @type {CreateCartPayloadPaymentMethod}
   * @memberof CreateCartPayload
   */
  paymentMethod: CreateCartPayloadPaymentMethod;
  /**
   *
   * @type {CreateCartPayloadDelivery}
   * @memberof CreateCartPayload
   */
  delivery: CreateCartPayloadDelivery;
  /**
   *
   * @type {boolean}
   * @memberof CreateCartPayload
   */
  subscribeToNewsletter: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateCartPayload
   */
  sampleSale: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateCartPayload
   */
  withAssembly: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  sampleSaleMeasurement?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  sampleSaleRabbetSize?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  sampleSaleReferenceNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayload
   */
  sampleSaleRotation?: string | null;
  /**
   *
   * @type {Array<DiscountRecords>}
   * @memberof CreateCartPayload
   */
  discountRecords: Array<DiscountRecords>;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateCartPayload
   */
  internalNotes: Array<string>;
}
/**
 *
 * @export
 * @interface CreateCartPayloadDelivery
 */
export interface CreateCartPayloadDelivery {
  /**
   *
   * @type {string}
   * @memberof CreateCartPayloadDelivery
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof CreateCartPayloadDelivery
   */
  date: string;
}
/**
 *
 * @export
 * @interface CreateCartPayloadPaymentMethod
 */
export interface CreateCartPayloadPaymentMethod {
  /**
   *
   * @type {string}
   * @memberof CreateCartPayloadPaymentMethod
   */
  method: string;
  /**
   *
   * @type {CreateCartPayloadPaymentMethodData}
   * @memberof CreateCartPayloadPaymentMethod
   */
  data: CreateCartPayloadPaymentMethodData;
}
/**
 *
 * @export
 * @interface CreateCartPayloadPaymentMethodData
 */
export interface CreateCartPayloadPaymentMethodData {
  /**
   *
   * @type {string}
   * @memberof CreateCartPayloadPaymentMethodData
   */
  issuer: string;
}
/**
 *
 * @export
 * @interface CreateCartPayloadStandardProductPayment
 */
export interface CreateCartPayloadStandardProductPayment {
  /**
   *
   * @type {string}
   * @memberof CreateCartPayloadStandardProductPayment
   */
  paymentType: string;
  /**
   *
   * @type {number}
   * @memberof CreateCartPayloadStandardProductPayment
   */
  paymentMethod: number;
  /**
   *
   * @type {number}
   * @memberof CreateCartPayloadStandardProductPayment
   */
  paymentBank: number;
}
/**
 *
 * @export
 * @interface CreateCartResponse
 */
export interface CreateCartResponse {
  /**
   *
   * @type {string}
   * @memberof CreateCartResponse
   */
  shoppingCartId?: string;
}
/**
 *
 * @export
 * @interface CreateOrderPayload
 */
export interface CreateOrderPayload {
  /**
   *
   * @type {Array<string>}
   * @memberof CreateOrderPayload
   */
  voucherCodes: Array<string>;
  /**
   *
   * @type {Address}
   * @memberof CreateOrderPayload
   */
  address: Address;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPayload
   */
  payDirect: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPayload
   */
  deferredPayment: boolean;
  /**
   *
   * @type {Array<OrderProduct>}
   * @memberof CreateOrderPayload
   */
  products: Array<OrderProduct>;
  /**
   *
   * @type {Array<SupplyProduct>}
   * @memberof CreateOrderPayload
   */
  supplyProducts: Array<SupplyProduct>;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPayload
   */
  sampleSale: boolean;
}
/**
 *
 * @export
 * @interface CreateOrderPaymentLinkPayload
 */
export interface CreateOrderPaymentLinkPayload {
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentLinkPayload
   */
  paymentType: string;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentLinkPayload
   */
  paymentMethod: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentLinkPayload
   */
  paymentBank: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentLinkPayload
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface CreateOrderPaymentPayload
 */
export interface CreateOrderPaymentPayload {
  /**
   *
   * @type {CreateOrderPaymentPayloadPaymentMethod}
   * @memberof CreateOrderPaymentPayload
   */
  paymentMethod: CreateOrderPaymentPayloadPaymentMethod;
  /**
   *
   * @type {CreateOrderPaymentPayloadWarrantyPackage}
   * @memberof CreateOrderPaymentPayload
   */
  warrantyPackage?: CreateOrderPaymentPayloadWarrantyPackage;
}
/**
 *
 * @export
 * @interface CreateOrderPaymentPayloadPaymentMethod
 */
export interface CreateOrderPaymentPayloadPaymentMethod {
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentPayloadPaymentMethod
   */
  action: string;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentPayloadPaymentMethod
   */
  method: number;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentPayloadPaymentMethod
   */
  type: string;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentPayloadPaymentMethod
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentPayloadPaymentMethod
   */
  bank: string;
}
/**
 *
 * @export
 * @interface CreateOrderPaymentPayloadWarrantyPackage
 */
export interface CreateOrderPaymentPayloadWarrantyPackage {
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentPayloadWarrantyPackage
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentPayloadWarrantyPackage
   */
  packageId?: string | null;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentPayloadWarrantyPackage
   */
  duration?: number;
  /**
   *
   * @type {number}
   * @memberof CreateOrderPaymentPayloadWarrantyPackage
   */
  price?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentPayloadWarrantyPackage
   */
  exists: boolean;
}
/**
 *
 * @export
 * @interface CreateOrderPaymentResponse
 */
export interface CreateOrderPaymentResponse {
  /**
   *
   * @type {string}
   * @memberof CreateOrderPaymentResponse
   */
  paymentUrl: string;
}
/**
 *
 * @export
 * @interface CreateOrderResponse
 */
export interface CreateOrderResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof CreateOrderResponse
   */
  voucherCodes: Array<string>;
  /**
   *
   * @type {Address}
   * @memberof CreateOrderResponse
   */
  address: Address;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderResponse
   */
  payDirect: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderResponse
   */
  deferredPayment: boolean;
  /**
   *
   * @type {Array<OrderProduct>}
   * @memberof CreateOrderResponse
   */
  products: Array<OrderProduct>;
  /**
   *
   * @type {Array<SupplyProduct>}
   * @memberof CreateOrderResponse
   */
  supplyProducts: Array<SupplyProduct>;
}
/**
 *
 * @export
 * @interface CreateOrderWarrantyPayload
 */
export interface CreateOrderWarrantyPayload {
  /**
   *
   * @type {string}
   * @memberof CreateOrderWarrantyPayload
   */
  orderId: string;
  /**
   *
   * @type {string}
   * @memberof CreateOrderWarrantyPayload
   */
  packageId: string;
}
/**
 *
 * @export
 * @interface CreateOrderWarrantyResponse
 */
export interface CreateOrderWarrantyResponse {
  /**
   *
   * @type {string}
   * @memberof CreateOrderWarrantyResponse
   */
  orderId: string;
  /**
   *
   * @type {string}
   * @memberof CreateOrderWarrantyResponse
   */
  packageId: string;
}
/**
 *
 * @export
 * @interface CreateStandardOrderPaymentLinkPayload
 */
export interface CreateStandardOrderPaymentLinkPayload {
  /**
   *
   * @type {string}
   * @memberof CreateStandardOrderPaymentLinkPayload
   */
  paymentType: string;
  /**
   *
   * @type {number}
   * @memberof CreateStandardOrderPaymentLinkPayload
   */
  paymentMethod: number;
  /**
   *
   * @type {number}
   * @memberof CreateStandardOrderPaymentLinkPayload
   */
  paymentBank: number;
  /**
   *
   * @type {number}
   * @memberof CreateStandardOrderPaymentLinkPayload
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface DealerDiscount
 */
export interface DealerDiscount {
  /**
   *
   * @type {string}
   * @memberof DealerDiscount
   */
  productCode: string;
  /**
   *
   * @type {number}
   * @memberof DealerDiscount
   */
  discount: number;
}
/**
 *
 * @export
 * @interface DiscountCode
 */
export interface DiscountCode {
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  type: string;
  /**
   *
   * @type {number}
   * @memberof DiscountCode
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  startDate: string;
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  endDate: string;
  /**
   *
   * @type {boolean}
   * @memberof DiscountCode
   */
  applyAlways: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DiscountCode
   */
  applyOnce: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DiscountCode
   */
  excludeSupply: boolean;
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  appliedAt: string;
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof DiscountCode
   */
  dateModified: string;
  /**
   *
   * @type {boolean}
   * @memberof DiscountCode
   */
  multiple: boolean;
}
/**
 *
 * @export
 * @interface DiscountRecords
 */
export interface DiscountRecords {
  /**
   *
   * @type {string}
   * @memberof DiscountRecords
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DiscountRecords
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof DiscountRecords
   */
  type: string;
  /**
   *
   * @type {number}
   * @memberof DiscountRecords
   */
  value: number;
}
/**
 *
 * @export
 * @interface ExtraOptions
 */
export interface ExtraOptions {
  /**
   *
   * @type {string}
   * @memberof ExtraOptions
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ExtraOptions
   */
  code: string;
  /**
   *
   * @type {number}
   * @memberof ExtraOptions
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof ExtraOptions
   */
  amount: number;
}
/**
 *
 * @export
 * @interface ExtraOptionsType
 */
export interface ExtraOptionsType {
  /**
   *
   * @type {string}
   * @memberof ExtraOptionsType
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof ExtraOptionsType
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface Filter
 */
export interface Filter {
  /**
   *
   * @type {Where}
   * @memberof Filter
   */
  where: Where;
  /**
   *
   * @type {Array<string>}
   * @memberof Filter
   */
  fields: Array<string>;
}
/**
 *
 * @export
 * @interface GetBumbalBeforeDaysResponse
 */
export interface GetBumbalBeforeDaysResponse {
  /**
   *
   * @type {number}
   * @memberof GetBumbalBeforeDaysResponse
   */
  days: number;
}
/**
 *
 * @export
 * @interface GetCartResponse
 */
export interface GetCartResponse {
  /**
   *
   * @type {string}
   * @memberof GetCartResponse
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof GetCartResponse
   */
  emailAddress: string;
  /**
   *
   * @type {Address}
   * @memberof GetCartResponse
   */
  address: Address;
  /**
   *
   * @type {boolean}
   * @memberof GetCartResponse
   */
  addressValid: boolean;
  /**
   *
   * @type {string}
   * @memberof GetCartResponse
   */
  discountCode: string;
  /**
   *
   * @type {Array<SupplyProduct>}
   * @memberof GetCartResponse
   */
  supplyProducts: Array<SupplyProduct>;
  /**
   *
   * @type {Array<Product>}
   * @memberof GetCartResponse
   */
  products: Array<Product>;
  /**
   *
   * @type {Array<CategoryStandardProduct>}
   * @memberof GetCartResponse
   */
  standardProducts: Array<CategoryStandardProduct>;
  /**
   *
   * @type {string}
   * @memberof GetCartResponse
   */
  pickupWarehouse: string;
  /**
   *
   * @type {CheckoutPayloadStandardProductPayment}
   * @memberof GetCartResponse
   */
  standardProductPayment: CheckoutPayloadStandardProductPayment;
  /**
   *
   * @type {string}
   * @memberof GetCartResponse
   */
  saleLocation: string;
  /**
   *
   * @type {boolean}
   * @memberof GetCartResponse
   */
  isSelfAssembly?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetCartResponse
   */
  withAssembly: boolean;
  /**
   *
   * @type {string}
   * @memberof GetCartResponse
   */
  bumbalFlow?: string;
  /**
   *
   * @type {number}
   * @memberof GetCartResponse
   */
  deliveryCosts?: number;
  /**
   *
   * @type {string}
   * @memberof GetCartResponse
   */
  shoppingCartId: string;
  /**
   *
   * @type {number}
   * @memberof GetCartResponse
   */
  totalPrice: number;
  /**
   *
   * @type {CreateCartPayloadPaymentMethod}
   * @memberof GetCartResponse
   */
  paymentMethod: CreateCartPayloadPaymentMethod;
  /**
   *
   * @type {CreateCartPayloadDelivery}
   * @memberof GetCartResponse
   */
  delivery: CreateCartPayloadDelivery;
  /**
   *
   * @type {boolean}
   * @memberof GetCartResponse
   */
  subscribeToNewsletter: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetCartResponse
   */
  sampleSale: boolean;
  /**
   *
   * @type {WarrantyPackage}
   * @memberof GetCartResponse
   */
  warrantyPackage?: WarrantyPackage;
  /**
   *
   * @type {Array<string>}
   * @memberof GetCartResponse
   */
  internalNotes: Array<string>;
  /**
   *
   * @type {string}
   * @memberof GetCartResponse
   */
  orderId: string;
  /**
   *
   * @type {Array<DiscountRecords>}
   * @memberof GetCartResponse
   */
  discountRecords: Array<DiscountRecords>;
}
/**
 *
 * @export
 * @interface GetDeliveryPriceResponse
 */
export interface GetDeliveryPriceResponse {
  /**
   *
   * @type {number}
   * @memberof GetDeliveryPriceResponse
   */
  amount: number;
}
/**
 *
 * @export
 * @interface GetOrderBumbalDataResponse
 */
export interface GetOrderBumbalDataResponse {
  /**
   *
   * @type {string}
   * @memberof GetOrderBumbalDataResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderBumbalDataResponse
   */
  number: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderBumbalDataResponse
   */
  bumbalId: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderBumbalDataResponse
   */
  date: string;
}
/**
 *
 * @export
 * @interface GetOrderPaymentDataResponse
 */
export interface GetOrderPaymentDataResponse {
  /**
   *
   * @type {string}
   * @memberof GetOrderPaymentDataResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderPaymentDataResponse
   */
  orderNumber: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderPaymentDataResponse
   */
  status: string;
  /**
   *
   * @type {boolean}
   * @memberof GetOrderPaymentDataResponse
   */
  payDirect: boolean;
  /**
   *
   * @type {string}
   * @memberof GetOrderPaymentDataResponse
   */
  paymentStatus: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderPaymentDataResponse
   */
  measurementDate: string;
  /**
   *
   * @type {number}
   * @memberof GetOrderPaymentDataResponse
   */
  paid: number;
  /**
   *
   * @type {number}
   * @memberof GetOrderPaymentDataResponse
   */
  total: number;
  /**
   *
   * @type {number}
   * @memberof GetOrderPaymentDataResponse
   */
  supplyPaid: number;
  /**
   *
   * @type {number}
   * @memberof GetOrderPaymentDataResponse
   */
  supplyTotal: number;
  /**
   *
   * @type {Array<OrderPayment>}
   * @memberof GetOrderPaymentDataResponse
   */
  payments?: Array<OrderPayment>;
}
/**
 *
 * @export
 * @interface GetOrderResponse
 */
export interface GetOrderResponse {
  /**
   *
   * @type {string}
   * @memberof GetOrderResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderResponse
   */
  orderNumber: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderResponse
   */
  paymentStatus: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderResponse
   */
  status: string;
  /**
   *
   * @type {ShippingAddress}
   * @memberof GetOrderResponse
   */
  shippingAddress: ShippingAddress;
  /**
   *
   * @type {Array<OrderProduct>}
   * @memberof GetOrderResponse
   */
  products: Array<OrderProduct>;
  /**
   *
   * @type {Array<SupplyProduct>}
   * @memberof GetOrderResponse
   */
  supplyProducts: Array<SupplyProduct>;
  /**
   *
   * @type {GetOrderPaymentDataResponse}
   * @memberof GetOrderResponse
   */
  paymentData: GetOrderPaymentDataResponse;
  /**
   *
   * @type {boolean}
   * @memberof GetOrderResponse
   */
  isSelfAssembly?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetOrderResponse
   */
  isZakelijkOrder?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetOrderResponse
   */
  invoiceEmail?: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderResponse
   */
  measurementDate: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderResponse
   */
  shipmentDate: string;
  /**
   *
   * @type {string}
   * @memberof GetOrderResponse
   */
  deliveryDate: string;
  /**
   *
   * @type {GetOrderShoppingCartResponse}
   * @memberof GetOrderResponse
   */
  shoppingCart?: GetOrderShoppingCartResponse;
  /**
   *
   * @type {WarrantyPackage}
   * @memberof GetOrderResponse
   */
  warrantyPackage?: WarrantyPackage;
  /**
   *
   * @type {number}
   * @memberof GetOrderResponse
   */
  warrantyOwnRiskPrice?: number;
  /**
   *
   * @type {Array<DiscountRecords>}
   * @memberof GetOrderResponse
   */
  discountRecords?: Array<DiscountRecords>;
  /**
   *
   * @type {Array<DealerDiscount>}
   * @memberof GetOrderResponse
   */
  dealerDiscounts?: Array<DealerDiscount>;
  /**
   *
   * @type {number}
   * @memberof GetOrderResponse
   */
  extraDiscounts?: number;
}
/**
 *
 * @export
 * @interface GetOrderShoppingCartResponse
 */
export interface GetOrderShoppingCartResponse {
  /**
   *
   * @type {boolean}
   * @memberof GetOrderShoppingCartResponse
   */
  sampleSale?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetOrderShoppingCartResponse
   */
  sampleSaleMeasurement?: string | null;
  /**
   *
   * @type {string}
   * @memberof GetOrderShoppingCartResponse
   */
  sampleSaleRabbetSize?: string | null;
  /**
   *
   * @type {string}
   * @memberof GetOrderShoppingCartResponse
   */
  sampleSaleReferenceNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof GetOrderShoppingCartResponse
   */
  sampleSaleRotation?: string | null;
}
/**
 *
 * @export
 * @interface GetStandardProductOrderResponse
 */
export interface GetStandardProductOrderResponse {
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  paymentStatus: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  saleLocation: string;
  /**
   *
   * @type {number}
   * @memberof GetStandardProductOrderResponse
   */
  mendrixOrderId: number;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  status: string;
  /**
   *
   * @type {Array<DiscountRecords>}
   * @memberof GetStandardProductOrderResponse
   */
  discountRecords: Array<DiscountRecords>;
  /**
   *
   * @type {number}
   * @memberof GetStandardProductOrderResponse
   */
  extraProductDiscount: number;
  /**
   *
   * @type {boolean}
   * @memberof GetStandardProductOrderResponse
   */
  disableCommunication: boolean;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  invoiceDivisionId: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  shippingDivisionId: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  dateModified: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  userIdCreated: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  userIdModified: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  emailAddress: string;
  /**
   *
   * @type {ShippingAddress}
   * @memberof GetStandardProductOrderResponse
   */
  shippingAddress: ShippingAddress;
  /**
   *
   * @type {InvoiceAddress}
   * @memberof GetStandardProductOrderResponse
   */
  invoiceAddress: InvoiceAddress;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  exactAccountId: string;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  standardOrderNumber: string;
  /**
   *
   * @type {number}
   * @memberof GetStandardProductOrderResponse
   */
  exactInvoicedAmount: number;
  /**
   *
   * @type {string}
   * @memberof GetStandardProductOrderResponse
   */
  exactSalesOrderId: string;
  /**
   *
   * @type {GetOrderPaymentDataResponse}
   * @memberof GetStandardProductOrderResponse
   */
  paymentData: GetOrderPaymentDataResponse;
  /**
   *
   * @type {Array<string>}
   * @memberof GetStandardProductOrderResponse
   */
  exactSalesInvoiceIds: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof GetStandardProductOrderResponse
   */
  exactSalesInvoiceAttachmentIds: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof GetStandardProductOrderResponse
   */
  exactFinishSalesOrder: boolean;
  /**
   *
   * @type {Array<StandardOrderProduct>}
   * @memberof GetStandardProductOrderResponse
   */
  products: Array<StandardOrderProduct>;
  /**
   *
   * @type {number}
   * @memberof GetStandardProductOrderResponse
   */
  payableAmount: number;
  /**
   *
   * @type {number}
   * @memberof GetStandardProductOrderResponse
   */
  subtotalPrice: number;
  /**
   *
   * @type {number}
   * @memberof GetStandardProductOrderResponse
   */
  totalPrice: number;
}
/**
 *
 * @export
 * @interface GetZakelijkOrderResponse
 */
export interface GetZakelijkOrderResponse {
  /**
   *
   * @type {string}
   * @memberof GetZakelijkOrderResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof GetZakelijkOrderResponse
   */
  orderNumber: string;
  /**
   *
   * @type {string}
   * @memberof GetZakelijkOrderResponse
   */
  paymentStatus: string;
  /**
   *
   * @type {string}
   * @memberof GetZakelijkOrderResponse
   */
  status: string;
  /**
   *
   * @type {ShippingAddress}
   * @memberof GetZakelijkOrderResponse
   */
  shippingAddress: ShippingAddress;
  /**
   *
   * @type {Array<ZakelijkProduct>}
   * @memberof GetZakelijkOrderResponse
   */
  products: Array<ZakelijkProduct>;
  /**
   *
   * @type {Array<SupplyProduct>}
   * @memberof GetZakelijkOrderResponse
   */
  supplyProducts: Array<SupplyProduct>;
  /**
   *
   * @type {GetOrderPaymentDataResponse}
   * @memberof GetZakelijkOrderResponse
   */
  paymentData: GetOrderPaymentDataResponse;
  /**
   *
   * @type {boolean}
   * @memberof GetZakelijkOrderResponse
   */
  isSelfAssembly?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetZakelijkOrderResponse
   */
  isZakelijkOrder?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetZakelijkOrderResponse
   */
  invoiceEmail?: string;
  /**
   *
   * @type {string}
   * @memberof GetZakelijkOrderResponse
   */
  measurementDate: string;
  /**
   *
   * @type {string}
   * @memberof GetZakelijkOrderResponse
   */
  shipmentDate: string;
  /**
   *
   * @type {string}
   * @memberof GetZakelijkOrderResponse
   */
  deliveryDate: string;
  /**
   *
   * @type {GetOrderShoppingCartResponse}
   * @memberof GetZakelijkOrderResponse
   */
  shoppingCart?: GetOrderShoppingCartResponse;
  /**
   *
   * @type {WarrantyPackage}
   * @memberof GetZakelijkOrderResponse
   */
  warrantyPackage?: WarrantyPackage;
  /**
   *
   * @type {number}
   * @memberof GetZakelijkOrderResponse
   */
  warrantyOwnRiskPrice?: number;
  /**
   *
   * @type {Array<DiscountRecords>}
   * @memberof GetZakelijkOrderResponse
   */
  discountRecords?: Array<DiscountRecords>;
  /**
   *
   * @type {Array<DealerDiscount>}
   * @memberof GetZakelijkOrderResponse
   */
  dealerDiscounts?: Array<DealerDiscount>;
}
/**
 *
 * @export
 * @interface IcepayData
 */
export interface IcepayData {
  /**
   *
   * @type {string}
   * @memberof IcepayData
   */
  contractId: string;
  /**
   *
   * @type {string}
   * @memberof IcepayData
   */
  transactionId: string;
  /**
   *
   * @type {string}
   * @memberof IcepayData
   */
  transactionStatusCode: string;
  /**
   *
   * @type {string}
   * @memberof IcepayData
   */
  transactionStatusDetails: string;
  /**
   *
   * @type {string}
   * @memberof IcepayData
   */
  acquirerRequestUri: string;
  /**
   *
   * @type {string}
   * @memberof IcepayData
   */
  acquirerTransactionId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IcepayData
   */
  paymentDetails: Array<string>;
}
/**
 *
 * @export
 * @interface IcepayResponse
 */
export interface IcepayResponse {
  /**
   *
   * @type {IcepayData}
   * @memberof IcepayResponse
   */
  icepay: IcepayData;
  /**
   *
   * @type {string}
   * @memberof IcepayResponse
   */
  icepayId: string;
  /**
   *
   * @type {string}
   * @memberof IcepayResponse
   */
  paymentUrl: string;
  /**
   *
   * @type {string}
   * @memberof IcepayResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IcepayResponse
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof IcepayResponse
   */
  dateModified: string;
}
/**
 *
 * @export
 * @interface InternalNotesVisibilityResponse
 */
export interface InternalNotesVisibilityResponse {
  /**
   *
   * @type {boolean}
   * @memberof InternalNotesVisibilityResponse
   */
  canSeeInternalNotes: boolean;
}
/**
 *
 * @export
 * @interface InvoiceAddress
 */
export interface InvoiceAddress {
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  street: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  houseNumber: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  zip: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  municipality: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  province: string;
  /**
   *
   * @type {Location}
   * @memberof InvoiceAddress
   */
  location: Location;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  company: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  reference: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAddress
   */
  VAT: string;
}
/**
 *
 * @export
 * @interface Location
 */
export interface Location {
  /**
   *
   * @type {string}
   * @memberof Location
   */
  type: string;
}
/**
 *
 * @export
 * @interface Measurements
 */
export interface Measurements {
  /**
   *
   * @type {string}
   * @memberof Measurements
   */
  rotation?: string;
  /**
   *
   * @type {string}
   * @memberof Measurements
   */
  frameType?: string;
  /**
   *
   * @type {string}
   * @memberof Measurements
   */
  typeDeur?: string;
  /**
   *
   * @type {string}
   * @memberof Measurements
   */
  frameConnection?: string;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  hingeAmount?: number;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  easyToReach?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  deliverInParts?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  onLocation?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  extraFloor?: boolean;
  /**
   *
   * @type {string}
   * @memberof Measurements
   */
  typePlafond?: string;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  slideToWall?: boolean;
  /**
   *
   * @type {string}
   * @memberof Measurements
   */
  locationPlacement?: string;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  sparingPlafond?: number;
  /**
   *
   * @type {string}
   * @memberof Measurements
   */
  view?: string;
  /**
   *
   * @type {SelfAssemblyMeasurementsLeftStelprofiel}
   * @memberof Measurements
   */
  leftStelprofiel?: SelfAssemblyMeasurementsLeftStelprofiel;
  /**
   *
   * @type {SelfAssemblyMeasurementsLeftStelprofiel}
   * @memberof Measurements
   */
  rightStelprofiel?: SelfAssemblyMeasurementsLeftStelprofiel;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  hasFloorHeating?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  smokeAlarm?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  pipe?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  plint?: boolean;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  scheluwHangTop?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  scheluwHangBottom?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  scheluwSluitTop?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  scheluwSluitBottom?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  dagschoothoogte?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  hinge1?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  hinge2?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  hinge3?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  sponningsBreedte?: number;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  sponningsHoogte?: number;
  /**
   *
   * @type {SelfAssemblyMeasurementsSkews}
   * @memberof Measurements
   */
  skews?: SelfAssemblyMeasurementsSkews;
  /**
   *
   * @type {number}
   * @memberof Measurements
   */
  height?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof Measurements
   */
  widths?: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof Measurements
   */
  beams?: Array<number>;
  /**
   *
   * @type {Array<Array<number>>}
   * @memberof Measurements
   */
  verticalBeams?: Array<Array<number>>;
  /**
   *
   * @type {boolean}
   * @memberof Measurements
   */
  mirrored?: boolean;
}
/**
 *
 * @export
 * @interface OptionTemplate
 */
export interface OptionTemplate {
  /**
   *
   * @type {OptionTemplateMaterial}
   * @memberof OptionTemplate
   */
  material?: OptionTemplateMaterial;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  itemIconColor: string;
  /**
   *
   * @type {OptionTemplateConfiguration}
   * @memberof OptionTemplate
   */
  configuration: OptionTemplateConfiguration;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  type: string;
  /**
   *
   * @type {Array<string>}
   * @memberof OptionTemplate
   */
  typeRestriction: Array<string>;
  /**
   *
   * @type {number}
   * @memberof OptionTemplate
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof OptionTemplate
   */
  selfAssemblyDiscount?: number;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof OptionTemplate
   */
  default: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OptionTemplate
   */
  disabled: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof OptionTemplate
   */
  carrouselImageIds: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof OptionTemplate
   */
  carouselImageAltTexts?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  mainImageAltText?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof OptionTemplate
   */
  exclude: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof OptionTemplate
   */
  crossSoldOptions: Array<string>;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  groupLabel: string;
  /**
   *
   * @type {number}
   * @memberof OptionTemplate
   */
  minBeamCount: number;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  threeDColor?: string;
  /**
   *
   * @type {number}
   * @memberof OptionTemplate
   */
  threeDOpacity?: number;
  /**
   *
   * @type {boolean}
   * @memberof OptionTemplate
   */
  isCornerWallable?: boolean;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof OptionTemplate
   */
  imageId: string;
  /**
   *
   * @type {number}
   * @memberof OptionTemplate
   */
  order?: number;
  /**
   *
   * @type {number}
   * @memberof OptionTemplate
   */
  amount?: number;
}
/**
 *
 * @export
 * @interface OptionTemplateByFilterPayload
 */
export interface OptionTemplateByFilterPayload {
  /**
   *
   * @type {string}
   * @memberof OptionTemplateByFilterPayload
   */
  door: string;
  /**
   *
   * @type {Array<string>}
   * @memberof OptionTemplateByFilterPayload
   */
  chosenOptions: Array<string>;
}
/**
 *
 * @export
 * @interface OptionTemplateConfiguration
 */
export interface OptionTemplateConfiguration {
  /**
   *
   * @type {Array<OptionTemplateConfigurationElement>}
   * @memberof OptionTemplateConfiguration
   */
  elements?: Array<OptionTemplateConfigurationElement>;
  /**
   *
   * @type {number}
   * @memberof OptionTemplateConfiguration
   */
  nElements?: number;
}
/**
 *
 * @export
 * @interface OptionTemplateConfigurationElement
 */
export interface OptionTemplateConfigurationElement {
  /**
   *
   * @type {string}
   * @memberof OptionTemplateConfigurationElement
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof OptionTemplateConfigurationElement
   */
  description?: string;
}
/**
 *
 * @export
 * @interface OptionTemplateMaterial
 */
export interface OptionTemplateMaterial {
  /**
   *
   * @type {string}
   * @memberof OptionTemplateMaterial
   */
  color?: string;
  /**
   *
   * @type {number}
   * @memberof OptionTemplateMaterial
   */
  roughness?: number;
  /**
   *
   * @type {number}
   * @memberof OptionTemplateMaterial
   */
  transmission?: number;
  /**
   *
   * @type {number}
   * @memberof OptionTemplateMaterial
   */
  metalness?: number;
  /**
   *
   * @type {string}
   * @memberof OptionTemplateMaterial
   */
  codeName?: string;
}
/**
 *
 * @export
 * @interface OptionTemplatePayload
 */
export interface OptionTemplatePayload {
  /**
   *
   * @type {Filter}
   * @memberof OptionTemplatePayload
   */
  filter: Filter;
}
/**
 *
 * @export
 * @interface OptionTemplatesByFilterResponse
 */
export interface OptionTemplatesByFilterResponse {
  /**
   *
   * @type {Array<OptionTemplate>}
   * @memberof OptionTemplatesByFilterResponse
   */
  glass: Array<OptionTemplate>;
  /**
   *
   * @type {Array<OptionTemplate>}
   * @memberof OptionTemplatesByFilterResponse
   */
  preset: Array<OptionTemplate>;
  /**
   *
   * @type {Array<OptionTemplate>}
   * @memberof OptionTemplatesByFilterResponse
   */
  color: Array<OptionTemplate>;
  /**
   *
   * @type {Array<OptionTemplate>}
   * @memberof OptionTemplatesByFilterResponse
   */
  handle: Array<OptionTemplate>;
  /**
   *
   * @type {Array<OptionTemplate>}
   * @memberof OptionTemplatesByFilterResponse
   */
  extra: Array<OptionTemplate>;
  /**
   *
   * @type {Array<OptionTemplate>}
   * @memberof OptionTemplatesByFilterResponse
   */
  door: Array<OptionTemplate>;
  /**
   *
   * @type {Array<OptionTemplate>}
   * @memberof OptionTemplatesByFilterResponse
   */
  background: Array<OptionTemplate>;
  /**
   *
   * @type {Array<OptionTemplate>}
   * @memberof OptionTemplatesByFilterResponse
   */
  layout: Array<OptionTemplate>;
}
/**
 *
 * @export
 * @interface OrderPayment
 */
export interface OrderPayment {
  /**
   *
   * @type {string}
   * @memberof OrderPayment
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof OrderPayment
   */
  orderType: string;
  /**
   *
   * @type {number}
   * @memberof OrderPayment
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof OrderPayment
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof OrderPayment
   */
  paymentType: string;
  /**
   *
   * @type {OrderPaymentTransaction}
   * @memberof OrderPayment
   */
  transaction?: OrderPaymentTransaction;
}
/**
 *
 * @export
 * @interface OrderPaymentTransaction
 */
export interface OrderPaymentTransaction {
  /**
   *
   * @type {string}
   * @memberof OrderPaymentTransaction
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentTransaction
   */
  method?: string;
}
/**
 *
 * @export
 * @interface OrderProduct
 */
export interface OrderProduct {
  /**
   *
   * @type {string}
   * @memberof OrderProduct
   */
  imageId: string;
  /**
   *
   * @type {string}
   * @memberof OrderProduct
   */
  layoutOption: string;
  /**
   *
   * @type {string}
   * @memberof OrderProduct
   */
  colorOption: string;
  /**
   *
   * @type {string}
   * @memberof OrderProduct
   */
  glassOption: string;
  /**
   *
   * @type {string}
   * @memberof OrderProduct
   */
  handleOption: string;
  /**
   *
   * @type {string}
   * @memberof OrderProduct
   */
  doorOption: string;
  /**
   *
   * @type {string}
   * @memberof OrderProduct
   */
  isSelfAssembly?: string;
  /**
   *
   * @type {number}
   * @memberof OrderProduct
   */
  selfAssemblyDiscount?: number;
  /**
   *
   * @type {number}
   * @memberof OrderProduct
   */
  linkCornerWallProductIndex?: number | null;
  /**
   *
   * @type {string}
   * @memberof OrderProduct
   */
  cornerWallLinkProductId?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrderProduct
   */
  totalPrice: number;
  /**
   *
   * @type {Array<ExtraOptions>}
   * @memberof OrderProduct
   */
  extraOptions: Array<ExtraOptions>;
  /**
   *
   * @type {Measurements}
   * @memberof OrderProduct
   */
  measurements: Measurements;
}
/**
 *
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  visibleName: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  minAmount: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethod
   */
  maxAmount: string;
  /**
   *
   * @type {Array<string>}
   * @memberof PaymentMethod
   */
  countries: Array<string>;
  /**
   *
   * @type {Array<PaymentMethodBank>}
   * @memberof PaymentMethod
   */
  banks?: Array<PaymentMethodBank>;
  /**
   *
   * @type {PaymentMethodBrand}
   * @memberof PaymentMethod
   */
  brand?: PaymentMethodBrand;
}
/**
 *
 * @export
 * @interface PaymentMethodBank
 */
export interface PaymentMethodBank {
  /**
   *
   * @type {string}
   * @memberof PaymentMethodBank
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodBank
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodBank
   */
  visibleName: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodBank
   */
  image: string;
}
/**
 *
 * @export
 * @interface PaymentMethodBrand
 */
export interface PaymentMethodBrand {
  /**
   *
   * @type {string}
   * @memberof PaymentMethodBrand
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodBrand
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodBrand
   */
  image: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodBrand
   */
  publicDescription: string;
}
/**
 *
 * @export
 * @interface PaymentMonthlyPayload
 */
export interface PaymentMonthlyPayload {
  /**
   *
   * @type {number}
   * @memberof PaymentMonthlyPayload
   */
  loanAmount: number;
  /**
   *
   * @type {number}
   * @memberof PaymentMonthlyPayload
   */
  duration?: number;
}
/**
 *
 * @export
 * @interface PaymentMonthlyResponse
 */
export interface PaymentMonthlyResponse {
  /**
   *
   * @type {number}
   * @memberof PaymentMonthlyResponse
   */
  monthlyPayment: number;
}
/**
 *
 * @export
 * @interface Price
 */
export interface Price {
  /**
   *
   * @type {number}
   * @memberof Price
   */
  price?: number;
}
/**
 *
 * @export
 * @interface Product
 */
export interface Product {
  /**
   *
   * @type {Specification}
   * @memberof Product
   */
  doorLayout: Specification;
  /**
   *
   * @type {Specification}
   * @memberof Product
   */
  doorColor: Specification;
  /**
   *
   * @type {Specification}
   * @memberof Product
   */
  glassType: Specification;
  /**
   *
   * @type {Specification}
   * @memberof Product
   */
  doorHandle: Specification;
  /**
   *
   * @type {Specification}
   * @memberof Product
   */
  doorType: Specification;
  /**
   *
   * @type {Array<ExtraOptionsType>}
   * @memberof Product
   */
  extraOptions: Array<ExtraOptionsType>;
  /**
   *
   * @type {Array<string>}
   * @memberof Product
   */
  extraOptionsNames?: Array<string>;
  /**
   *
   * @type {Array<number>}
   * @memberof Product
   */
  extraOptionsPrices?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  label?: string;
  /**
   *
   * @type {boolean}
   * @memberof Product
   */
  isSelfAssembly?: boolean;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  selfAssemblyDiscount?: number;
  /**
   *
   * @type {Measurements}
   * @memberof Product
   */
  measurements: Measurements;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  cornerWallIndex?: number | null;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  cornerWallProductId?: string | null;
  /**
   *
   * @type {number}
   * @memberof Product
   */
  totalPrice: number | null;
  /**
   *
   * @type {string}
   * @memberof Product
   */
  preset: string;
}
/**
 *
 * @export
 * @interface ProductReview
 */
export interface ProductReview {
  /**
   *
   * @type {ReviewConsumer}
   * @memberof ProductReview
   */
  consumer: ReviewConsumer;
  /**
   *
   * @type {string}
   * @memberof ProductReview
   */
  content: string;
  /**
   *
   * @type {string}
   * @memberof ProductReview
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof ProductReview
   */
  createdAt?: string;
  /**
   *
   * @type {number}
   * @memberof ProductReview
   */
  stars: number;
  /**
   *
   * @type {Array<Array<AttachmentImage>>}
   * @memberof ProductReview
   */
  attachments?: Array<Array<AttachmentImage>>;
}
/**
 *
 * @export
 * @interface ProductReviewsStatsResponse
 */
export interface ProductReviewsStatsResponse {
  /**
   *
   * @type {number}
   * @memberof ProductReviewsStatsResponse
   */
  starsAverage?: number;
  /**
   *
   * @type {ReviewsStatsNumberOfReviews}
   * @memberof ProductReviewsStatsResponse
   */
  numberOfReviews?: ReviewsStatsNumberOfReviews;
}
/**
 *
 * @export
 * @interface RemoveOrderDirectDiscountResponse
 */
export interface RemoveOrderDirectDiscountResponse {
  /**
   *
   * @type {number}
   * @memberof RemoveOrderDirectDiscountResponse
   */
  newAmount: number;
}
/**
 *
 * @export
 * @interface Review
 */
export interface Review {
  /**
   *
   * @type {ReviewConsumer}
   * @memberof Review
   */
  consumer: ReviewConsumer;
  /**
   *
   * @type {string}
   * @memberof Review
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof Review
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof Review
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof Review
   */
  date?: string;
  /**
   *
   * @type {number}
   * @memberof Review
   */
  stars: number;
  /**
   *
   * @type {Array<Array<AttachmentImage>>}
   * @memberof Review
   */
  attachments?: Array<Array<AttachmentImage>>;
}
/**
 *
 * @export
 * @interface ReviewConsumer
 */
export interface ReviewConsumer {
  /**
   *
   * @type {string}
   * @memberof ReviewConsumer
   */
  displayName: string;
}
/**
 *
 * @export
 * @interface ReviewsStatsNumberOfReviews
 */
export interface ReviewsStatsNumberOfReviews {
  /**
   *
   * @type {number}
   * @memberof ReviewsStatsNumberOfReviews
   */
  total?: number;
}
/**
 *
 * @export
 * @interface ReviewsStatsResponse
 */
export interface ReviewsStatsResponse {
  /**
   *
   * @type {ReviewsStatsScore}
   * @memberof ReviewsStatsResponse
   */
  score?: ReviewsStatsScore;
  /**
   *
   * @type {ReviewsStatsNumberOfReviews}
   * @memberof ReviewsStatsResponse
   */
  numberOfReviews?: ReviewsStatsNumberOfReviews;
}
/**
 *
 * @export
 * @interface ReviewsStatsScore
 */
export interface ReviewsStatsScore {
  /**
   *
   * @type {number}
   * @memberof ReviewsStatsScore
   */
  trustScore?: number;
}
/**
 *
 * @export
 * @interface SelfAssemblyMeasurements
 */
export interface SelfAssemblyMeasurements {
  /**
   *
   * @type {string}
   * @memberof SelfAssemblyMeasurements
   */
  rotation?: string;
  /**
   *
   * @type {string}
   * @memberof SelfAssemblyMeasurements
   */
  frameType?: string;
  /**
   *
   * @type {string}
   * @memberof SelfAssemblyMeasurements
   */
  typeDeur?: string;
  /**
   *
   * @type {string}
   * @memberof SelfAssemblyMeasurements
   */
  frameConnection?: string;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  hingeAmount?: number;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  easyToReach?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  deliverInParts?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  onLocation?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  extraFloor?: boolean;
  /**
   *
   * @type {string}
   * @memberof SelfAssemblyMeasurements
   */
  typePlafond?: string;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  slideToWall?: boolean;
  /**
   *
   * @type {string}
   * @memberof SelfAssemblyMeasurements
   */
  locationPlacement?: string;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  sparingPlafond?: number;
  /**
   *
   * @type {string}
   * @memberof SelfAssemblyMeasurements
   */
  view?: string;
  /**
   *
   * @type {SelfAssemblyMeasurementsLeftStelprofiel}
   * @memberof SelfAssemblyMeasurements
   */
  leftStelprofiel?: SelfAssemblyMeasurementsLeftStelprofiel;
  /**
   *
   * @type {SelfAssemblyMeasurementsLeftStelprofiel}
   * @memberof SelfAssemblyMeasurements
   */
  rightStelprofiel?: SelfAssemblyMeasurementsLeftStelprofiel;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  hasFloorHeating?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  smokeAlarm?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  pipe?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelfAssemblyMeasurements
   */
  plint?: boolean;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  scheluwHangTop?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  scheluwHangBottom?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  scheluwSluitTop?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  scheluwSluitBottom?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  dagschoothoogte?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  hinge1?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  hinge2?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  hinge3?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  sponningsBreedte?: number;
  /**
   *
   * @type {number}
   * @memberof SelfAssemblyMeasurements
   */
  sponningsHoogte?: number;
  /**
   *
   * @type {SelfAssemblyMeasurementsSkews}
   * @memberof SelfAssemblyMeasurements
   */
  skews?: SelfAssemblyMeasurementsSkews;
}
/**
 * @type SelfAssemblyMeasurementsLeftStelprofiel
 * @export
 */
export type SelfAssemblyMeasurementsLeftStelprofiel = boolean | string;

/**
 *
 * @export
 * @interface SelfAssemblyMeasurementsSkews
 */
export interface SelfAssemblyMeasurementsSkews {
  /**
   *
   * @type {Array<SkewMeasurements>}
   * @memberof SelfAssemblyMeasurementsSkews
   */
  width: Array<SkewMeasurements>;
  /**
   *
   * @type {Array<SkewMeasurements>}
   * @memberof SelfAssemblyMeasurementsSkews
   */
  height: Array<SkewMeasurements>;
  /**
   *
   * @type {Array<Array<SkewMeasurements>>}
   * @memberof SelfAssemblyMeasurementsSkews
   */
  openHeight: Array<Array<SkewMeasurements>>;
}
/**
 *
 * @export
 * @interface ShippingAddress
 */
export interface ShippingAddress {
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  street: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  houseNumber: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  zip: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  municipality: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  province: string;
  /**
   *
   * @type {Location}
   * @memberof ShippingAddress
   */
  location: Location;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  company: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  reference: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  VAT: string;
  /**
   *
   * @type {string}
   * @memberof ShippingAddress
   */
  email: string;
}
/**
 *
 * @export
 * @interface SkewMeasurements
 */
export interface SkewMeasurements {
  /**
   *
   * @type {number}
   * @memberof SkewMeasurements
   */
  size?: number;
  /**
   *
   * @type {number}
   * @memberof SkewMeasurements
   */
  offset?: number;
}
/**
 *
 * @export
 * @interface Specification
 */
export interface Specification {
  /**
   *
   * @type {string}
   * @memberof Specification
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Specification
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Specification
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof Specification
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof Specification
   */
  imageId: string;
  /**
   *
   * @type {string}
   * @memberof Specification
   */
  imageRef?: string;
  /**
   *
   * @type {number}
   * @memberof Specification
   */
  price?: number;
}
/**
 *
 * @export
 * @interface StandardOrderProduct
 */
export interface StandardOrderProduct {
  /**
   *
   * @type {number}
   * @memberof StandardOrderProduct
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof StandardOrderProduct
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof StandardOrderProduct
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof StandardOrderProduct
   */
  imageId: string;
  /**
   *
   * @type {string}
   * @memberof StandardOrderProduct
   */
  thumbnailId: string;
  /**
   *
   * @type {number}
   * @memberof StandardOrderProduct
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof StandardOrderProduct
   */
  totalPrice: number;
}
/**
 *
 * @export
 * @interface StandardProduct
 */
export interface StandardProduct {
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof StandardProduct
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof StandardProduct
   */
  amount: number;
  /**
   *
   * @type {boolean}
   * @memberof StandardProduct
   */
  disabled: boolean;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  sampleProductCode: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  exactArticleCode: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  imageId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  mainImageAltText: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  productType: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  deliveryMethod: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof StandardProduct
   */
  inStore: boolean;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  dateModified: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  userIdCreated: string;
  /**
   *
   * @type {string}
   * @memberof StandardProduct
   */
  userIdModified: string;
  /**
   *
   * @type {Array<StandardProductWarehouse>}
   * @memberof StandardProduct
   */
  exactArticleWarehouseLocation: Array<StandardProductWarehouse>;
  /**
   *
   * @type {Array<StandardProductDeliveryCondition>}
   * @memberof StandardProduct
   */
  deliveryCondition: Array<StandardProductDeliveryCondition>;
}
/**
 *
 * @export
 * @interface StandardProductCategory
 */
export interface StandardProductCategory {
  /**
   *
   * @type {string}
   * @memberof StandardProductCategory
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategory
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategory
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategory
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof StandardProductCategory
   */
  price: number;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategory
   */
  imageId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategory
   */
  mainImageAltText: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategory
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategory
   */
  dateModified: string;
  /**
   *
   * @type {boolean}
   * @memberof StandardProductCategory
   */
  disabled: boolean;
  /**
   *
   * @type {Array<StandardProductCategoryProduct>}
   * @memberof StandardProductCategory
   */
  product: Array<StandardProductCategoryProduct>;
  /**
   *
   * @type {number}
   * @memberof StandardProductCategory
   */
  sortOrder: number;
}
/**
 *
 * @export
 * @interface StandardProductCategoryProduct
 */
export interface StandardProductCategoryProduct {
  /**
   *
   * @type {string}
   * @memberof StandardProductCategoryProduct
   */
  productCategoryId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategoryProduct
   */
  standardProductId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategoryProduct
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategoryProduct
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductCategoryProduct
   */
  dateModified: string;
  /**
   *
   * @type {CategoryStandardProduct}
   * @memberof StandardProductCategoryProduct
   */
  standardProduct: CategoryStandardProduct;
}
/**
 *
 * @export
 * @interface StandardProductDeliveryCondition
 */
export interface StandardProductDeliveryCondition {
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryCondition
   */
  deliveryConditionId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryCondition
   */
  panelProductId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryCondition
   */
  conditionType: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryCondition
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryCondition
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryCondition
   */
  dateModified: string;
  /**
   *
   * @type {StandardProductDeliveryConditionDeliveryCondition}
   * @memberof StandardProductDeliveryCondition
   */
  deliveryCondition: StandardProductDeliveryConditionDeliveryCondition;
}
/**
 *
 * @export
 * @interface StandardProductDeliveryConditionDeliveryCondition
 */
export interface StandardProductDeliveryConditionDeliveryCondition {
  /**
   *
   * @type {number}
   * @memberof StandardProductDeliveryConditionDeliveryCondition
   */
  days: number;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryConditionDeliveryCondition
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryConditionDeliveryCondition
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryConditionDeliveryCondition
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryConditionDeliveryCondition
   */
  dateModified: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductDeliveryConditionDeliveryCondition
   */
  description: string;
}
/**
 *
 * @export
 * @interface StandardProductWarehouse
 */
export interface StandardProductWarehouse {
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  exactId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  itemId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  itemCode: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  itemDescription: string;
  /**
   *
   * @type {number}
   * @memberof StandardProductWarehouse
   */
  itemStock: number;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  storageLocationId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  storageLocationCode: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  storageLocationDescription: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  warehouseId: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  warehouseCode: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  warehouseDescription: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof StandardProductWarehouse
   */
  dateModified: string;
}
/**
 *
 * @export
 * @interface SupplyProduct
 */
export interface SupplyProduct {
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  description: string;
  /**
   *
   * @type {number}
   * @memberof SupplyProduct
   */
  price: number;
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  imageId: string;
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  picqerProductId: string;
  /**
   *
   * @type {boolean}
   * @memberof SupplyProduct
   */
  disabled: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof SupplyProduct
   */
  exclude: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof SupplyProduct
   */
  inStore: boolean;
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  exactArticleCode: string;
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof SupplyProduct
   */
  dateModified: string;
}
/**
 *
 * @export
 * @interface UpdateOrderPayload
 */
export interface UpdateOrderPayload {
  /**
   *
   * @type {string}
   * @memberof UpdateOrderPayload
   */
  paymentStatus?: string;
}
/**
 *
 * @export
 * @interface UpdateStandardProductOrderPayload
 */
export interface UpdateStandardProductOrderPayload {
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  emailAddress?: string;
  /**
   *
   * @type {Address}
   * @memberof UpdateStandardProductOrderPayload
   */
  address?: Address;
  /**
   *
   * @type {boolean}
   * @memberof UpdateStandardProductOrderPayload
   */
  addressValid?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  discountCode?: string;
  /**
   *
   * @type {Array<SupplyProduct>}
   * @memberof UpdateStandardProductOrderPayload
   */
  supplyProducts?: Array<SupplyProduct>;
  /**
   *
   * @type {Array<Product>}
   * @memberof UpdateStandardProductOrderPayload
   */
  products?: Array<Product>;
  /**
   *
   * @type {Array<CategoryStandardProduct>}
   * @memberof UpdateStandardProductOrderPayload
   */
  standardProducts?: Array<CategoryStandardProduct>;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  pickupWarehouse?: string;
  /**
   *
   * @type {CheckoutPayloadStandardProductPayment}
   * @memberof UpdateStandardProductOrderPayload
   */
  standardProductPayment?: CheckoutPayloadStandardProductPayment;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  saleLocation?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdateStandardProductOrderPayload
   */
  isSelfAssembly?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpdateStandardProductOrderPayload
   */
  withAssembly?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  bumbalFlow?: string;
  /**
   *
   * @type {number}
   * @memberof UpdateStandardProductOrderPayload
   */
  deliveryCosts?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  shoppingCartId?: string;
  /**
   *
   * @type {number}
   * @memberof UpdateStandardProductOrderPayload
   */
  totalPrice?: number;
  /**
   *
   * @type {CreateCartPayloadPaymentMethod}
   * @memberof UpdateStandardProductOrderPayload
   */
  paymentMethod?: CreateCartPayloadPaymentMethod;
  /**
   *
   * @type {CreateCartPayloadDelivery}
   * @memberof UpdateStandardProductOrderPayload
   */
  delivery?: CreateCartPayloadDelivery;
  /**
   *
   * @type {boolean}
   * @memberof UpdateStandardProductOrderPayload
   */
  subscribeToNewsletter?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpdateStandardProductOrderPayload
   */
  sampleSale?: boolean;
  /**
   *
   * @type {WarrantyPackage}
   * @memberof UpdateStandardProductOrderPayload
   */
  warrantyPackage?: WarrantyPackage;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateStandardProductOrderPayload
   */
  internalNotes?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof UpdateStandardProductOrderPayload
   */
  deleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  selectedReasonDeleted?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  dateDeleted?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateStandardProductOrderPayload
   */
  userIdDeleted?: string;
}
/**
 *
 * @export
 * @interface ValidateDiscountCodeResponse
 */
export interface ValidateDiscountCodeResponse {
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  type: string;
  /**
   *
   * @type {number}
   * @memberof ValidateDiscountCodeResponse
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  startDate: string;
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  endDate: string;
  /**
   *
   * @type {boolean}
   * @memberof ValidateDiscountCodeResponse
   */
  applyAlways: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ValidateDiscountCodeResponse
   */
  applyOnce: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ValidateDiscountCodeResponse
   */
  applyToOrder: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ValidateDiscountCodeResponse
   */
  applyToStandardOrder: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ValidateDiscountCodeResponse
   */
  applyToPanelOrder: boolean;
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  appliedAt: string;
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof ValidateDiscountCodeResponse
   */
  dateModified: string;
  /**
   *
   * @type {boolean}
   * @memberof ValidateDiscountCodeResponse
   */
  multiple: boolean;
  /**
   *
   * @type {Array<WarrantyPackageVoucher>}
   * @memberof ValidateDiscountCodeResponse
   */
  warrantyPackages: Array<WarrantyPackageVoucher>;
}
/**
 *
 * @export
 * @interface ValidateZipcodeResponse
 */
export interface ValidateZipcodeResponse {
  /**
   *
   * @type {string}
   * @memberof ValidateZipcodeResponse
   */
  houseNumber: string;
  /**
   *
   * @type {string}
   * @memberof ValidateZipcodeResponse
   */
  street: string;
  /**
   *
   * @type {string}
   * @memberof ValidateZipcodeResponse
   */
  zipCode: string;
  /**
   *
   * @type {string}
   * @memberof ValidateZipcodeResponse
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof ValidateZipcodeResponse
   */
  municipality: string;
  /**
   *
   * @type {string}
   * @memberof ValidateZipcodeResponse
   */
  province: string;
}
/**
 *
 * @export
 * @interface WarrantyPackage
 */
export interface WarrantyPackage {
  /**
   *
   * @type {string}
   * @memberof WarrantyPackage
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof WarrantyPackage
   */
  packageId: string;
  /**
   *
   * @type {string}
   * @memberof WarrantyPackage
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof WarrantyPackage
   */
  description: string;
  /**
   *
   * @type {number}
   * @memberof WarrantyPackage
   */
  price: number;
  /**
   *
   * @type {boolean}
   * @memberof WarrantyPackage
   */
  active: boolean;
  /**
   *
   * @type {number}
   * @memberof WarrantyPackage
   */
  duration: number;
  /**
   *
   * @type {string}
   * @memberof WarrantyPackage
   */
  code: string;
}
/**
 *
 * @export
 * @interface WarrantyPackageVoucher
 */
export interface WarrantyPackageVoucher {
  /**
   *
   * @type {string}
   * @memberof WarrantyPackageVoucher
   */
  id: string;
}
/**
 *
 * @export
 * @interface WarrantyPackagesResponse
 */
export interface WarrantyPackagesResponse {
  /**
   *
   * @type {Array<WarrantyPackage>}
   * @memberof WarrantyPackagesResponse
   */
  payNowPackages?: Array<WarrantyPackage>;
  /**
   *
   * @type {Array<WarrantyPackage>}
   * @memberof WarrantyPackagesResponse
   */
  payFullPackages?: Array<WarrantyPackage>;
  /**
   *
   * @type {WarrantyPackage}
   * @memberof WarrantyPackagesResponse
   */
  freeWarrantyPackage?: WarrantyPackage;
}
/**
 *
 * @export
 * @interface Where
 */
export interface Where {
  /**
   *
   * @type {string}
   * @memberof Where
   */
  type: string;
  /**
   *
   * @type {boolean}
   * @memberof Where
   */
  disabled: boolean;
}
/**
 *
 * @export
 * @interface ZakelijkProduct
 */
export interface ZakelijkProduct {
  /**
   *
   * @type {Specification}
   * @memberof ZakelijkProduct
   */
  doorLayout: Specification;
  /**
   *
   * @type {Specification}
   * @memberof ZakelijkProduct
   */
  doorColor: Specification;
  /**
   *
   * @type {Specification}
   * @memberof ZakelijkProduct
   */
  glassType: Specification;
  /**
   *
   * @type {Specification}
   * @memberof ZakelijkProduct
   */
  doorHandle: Specification;
  /**
   *
   * @type {Specification}
   * @memberof ZakelijkProduct
   */
  doorType: Specification;
  /**
   *
   * @type {Array<ExtraOptions>}
   * @memberof ZakelijkProduct
   */
  extraOptions: Array<ExtraOptions>;
  /**
   *
   * @type {Array<string>}
   * @memberof ZakelijkProduct
   */
  extraOptionsNames?: Array<string>;
  /**
   *
   * @type {Array<number>}
   * @memberof ZakelijkProduct
   */
  extraOptionsPrices?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof ZakelijkProduct
   */
  label?: string;
  /**
   *
   * @type {boolean}
   * @memberof ZakelijkProduct
   */
  isSelfAssembly?: boolean;
  /**
   *
   * @type {number}
   * @memberof ZakelijkProduct
   */
  selfAssemblyDiscount?: number;
  /**
   *
   * @type {Measurements}
   * @memberof ZakelijkProduct
   */
  measurements: Measurements;
  /**
   *
   * @type {number}
   * @memberof ZakelijkProduct
   */
  cornerWallIndex?: number | null;
  /**
   *
   * @type {string}
   * @memberof ZakelijkProduct
   */
  cornerWallProductId?: string | null;
  /**
   *
   * @type {number}
   * @memberof ZakelijkProduct
   */
  totalPrice: number | null;
  /**
   *
   * @type {string}
   * @memberof ZakelijkProduct
   */
  preset: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Initialize the checkout flow
     * @param {CheckoutPayload} [checkoutPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkout: async (
      checkoutPayload?: CheckoutPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/checkout`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkoutPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Generate a payment URL for an existing order
     * @param {string} orderId
     * @param {CreateOrderPaymentPayload} [createOrderPaymentPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrderPayment: async (
      orderId: string,
      createOrderPaymentPayload?: CreateOrderPaymentPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("createOrderPayment", "orderId", orderId);
      const localVarPath = `/api/orders/{order_id}/payment`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createOrderPaymentPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create a screenshot based on parameters
     * @param {string} door Door code
     * @param {string} layout Layout code
     * @param {string} glass Glass code
     * @param {string} color Color code
     * @param {string} handle Handle code
     * @param {string} webhookUrl Gers endpoint url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createScreenshot: async (
      door: string,
      layout: string,
      glass: string,
      color: string,
      handle: string,
      webhookUrl: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'door' is not null or undefined
      assertParamExists("createScreenshot", "door", door);
      // verify required parameter 'layout' is not null or undefined
      assertParamExists("createScreenshot", "layout", layout);
      // verify required parameter 'glass' is not null or undefined
      assertParamExists("createScreenshot", "glass", glass);
      // verify required parameter 'color' is not null or undefined
      assertParamExists("createScreenshot", "color", color);
      // verify required parameter 'handle' is not null or undefined
      assertParamExists("createScreenshot", "handle", handle);
      // verify required parameter 'webhookUrl' is not null or undefined
      assertParamExists("createScreenshot", "webhookUrl", webhookUrl);
      const localVarPath = `/api/screenshot`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (door !== undefined) {
        localVarQueryParameter["door"] = door;
      }

      if (layout !== undefined) {
        localVarQueryParameter["layout"] = layout;
      }

      if (glass !== undefined) {
        localVarQueryParameter["glass"] = glass;
      }

      if (color !== undefined) {
        localVarQueryParameter["color"] = color;
      }

      if (handle !== undefined) {
        localVarQueryParameter["handle"] = handle;
      }

      if (webhookUrl !== undefined) {
        localVarQueryParameter["webhook_url"] = webhookUrl;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Generate a payment URL for an existing standard product order
     * @param {string} orderId
     * @param {CreateOrderPaymentPayload} [createOrderPaymentPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStandardOrderPayment: async (
      orderId: string,
      createOrderPaymentPayload?: CreateOrderPaymentPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("createStandardOrderPayment", "orderId", orderId);
      const localVarPath =
        `/api/standardProductOrders/{order_id}/payment`.replace(
          `{${"order_id"}}`,
          encodeURIComponent(String(orderId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createOrderPaymentPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get available Bumbal dates
     * @param {string} orderId
     * @param {string} type
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersAvailableBumbalDates: async (
      orderId: string,
      type: string,
      dateFrom: string,
      dateTo: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersAvailableBumbalDates", "orderId", orderId);
      // verify required parameter 'type' is not null or undefined
      assertParamExists("gersAvailableBumbalDates", "type", type);
      // verify required parameter 'dateFrom' is not null or undefined
      assertParamExists("gersAvailableBumbalDates", "dateFrom", dateFrom);
      // verify required parameter 'dateTo' is not null or undefined
      assertParamExists("gersAvailableBumbalDates", "dateTo", dateTo);
      const localVarPath =
        `/api/orders/{order_id}/availableBumbalDates`.replace(
          `{${"order_id"}}`,
          encodeURIComponent(String(orderId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter["type"] = type;
      }

      if (dateFrom !== undefined) {
        localVarQueryParameter["dateFrom"] = dateFrom;
      }

      if (dateTo !== undefined) {
        localVarQueryParameter["dateTo"] = dateTo;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get available Standard Order Bumbal dates
     * @param {string} orderId
     * @param {string} type
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersAvailableStandardOrderBumbalDates: async (
      orderId: string,
      type: string,
      dateFrom: string,
      dateTo: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists(
        "gersAvailableStandardOrderBumbalDates",
        "orderId",
        orderId,
      );
      // verify required parameter 'type' is not null or undefined
      assertParamExists("gersAvailableStandardOrderBumbalDates", "type", type);
      // verify required parameter 'dateFrom' is not null or undefined
      assertParamExists(
        "gersAvailableStandardOrderBumbalDates",
        "dateFrom",
        dateFrom,
      );
      // verify required parameter 'dateTo' is not null or undefined
      assertParamExists(
        "gersAvailableStandardOrderBumbalDates",
        "dateTo",
        dateTo,
      );
      const localVarPath =
        `/api/StandardOrders/{order_id}/availableBumbalDates`.replace(
          `{${"order_id"}}`,
          encodeURIComponent(String(orderId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter["type"] = type;
      }

      if (dateFrom !== undefined) {
        localVarQueryParameter["dateFrom"] = dateFrom;
      }

      if (dateTo !== undefined) {
        localVarQueryParameter["dateTo"] = dateTo;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Check if ip in call is from a sale location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCheckSaleLocation: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/saleLocation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create Bumbal date
     * @param {string} orderId
     * @param {CreateBumbalDatePayload} [createBumbalDatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateBumbalDate: async (
      orderId: string,
      createBumbalDatePayload?: CreateBumbalDatePayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersCreateBumbalDate", "orderId", orderId);
      const localVarPath = `/api/orders/{order_id}/makeBumbalDate`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBumbalDatePayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create a cart on the Gers API
     * @param {CreateCartPayload} [createCartPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateCart: async (
      createCartPayload?: CreateCartPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/orders/cart/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCartPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create order on the Gers API
     * @param {CreateOrderPayload} [createOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateOrder: async (
      createOrderPayload?: CreateOrderPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/orders/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createOrderPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create payment link for orders
     * @param {string} orderId
     * @param {CreateOrderPaymentLinkPayload} [createOrderPaymentLinkPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateOrderPaymentLink: async (
      orderId: string,
      createOrderPaymentLinkPayload?: CreateOrderPaymentLinkPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersCreateOrderPaymentLink", "orderId", orderId);
      const localVarPath = `/api/Orders/{order_id}/createPaymentLink`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createOrderPaymentLinkPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Assign a warranty to an order
     * @param {CreateOrderWarrantyPayload} [createOrderWarrantyPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateOrderWarranty: async (
      createOrderWarrantyPayload?: CreateOrderWarrantyPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/warranties`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createOrderWarrantyPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create Bumbal date
     * @param {string} orderId
     * @param {CreateBumbalDatePayload} [createBumbalDatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateStandardProductOrderBumbalDate: async (
      orderId: string,
      createBumbalDatePayload?: CreateBumbalDatePayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists(
        "gersCreateStandardProductOrderBumbalDate",
        "orderId",
        orderId,
      );
      const localVarPath =
        `/api/StandardOrders/{order_id}/makeBumbalAppointment`.replace(
          `{${"order_id"}}`,
          encodeURIComponent(String(orderId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBumbalDatePayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create payment link for standard orders
     * @param {string} orderId
     * @param {CreateStandardOrderPaymentLinkPayload} [createStandardOrderPaymentLinkPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateStandardProductOrderPaymentLink: async (
      orderId: string,
      createStandardOrderPaymentLinkPayload?: CreateStandardOrderPaymentLinkPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists(
        "gersCreateStandardProductOrderPaymentLink",
        "orderId",
        orderId,
      );
      const localVarPath =
        `/api/StandardOrders/{order_id}/createPaymentLink`.replace(
          `{${"order_id"}}`,
          encodeURIComponent(String(orderId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStandardOrderPaymentLinkPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersDeleteOrder: async (
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersDeleteOrder", "orderId", orderId);
      const localVarPath = `/api/orders/{order_id}`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Delete a standard product order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersDeleteStandardOrder: async (
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersDeleteStandardOrder", "orderId", orderId);
      const localVarPath = `/api/standardorders/{order_id}`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get discount codes from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersDiscountCodes: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/discountcodes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Generate an Icepay payment link
     * @param {string} data
     * @param {string} method
     * @param {string} issuer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGenerateIcepayLink: async (
      data: string,
      method: string,
      issuer: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'data' is not null or undefined
      assertParamExists("gersGenerateIcepayLink", "data", data);
      // verify required parameter 'method' is not null or undefined
      assertParamExists("gersGenerateIcepayLink", "method", method);
      // verify required parameter 'issuer' is not null or undefined
      assertParamExists("gersGenerateIcepayLink", "issuer", issuer);
      const localVarPath = `/api/orders/getIcepayLink`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (data !== undefined) {
        localVarQueryParameter["data"] = data;
      }

      if (method !== undefined) {
        localVarQueryParameter["method"] = method;
      }

      if (issuer !== undefined) {
        localVarQueryParameter["issuer"] = issuer;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the cart data from the gers api
     * @param {string} cartId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetCart: async (
      cartId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'cartId' is not null or undefined
      assertParamExists("gersGetCart", "cartId", cartId);
      const localVarPath = `/api/cart/{cart_id}`.replace(
        `{${"cart_id"}}`,
        encodeURIComponent(String(cartId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get dealer discounts by KVK number
     * @param {string} kvk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetDealerDiscountsByKVK: async (
      kvk: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'kvk' is not null or undefined
      assertParamExists("gersGetDealerDiscountsByKVK", "kvk", kvk);
      const localVarPath = `/api/Dealers/discounts-by-kvk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (kvk !== undefined) {
        localVarQueryParameter["kvk"] = kvk;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the delivery price for the standard product order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetDeliveryPrice: async (
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersGetDeliveryPrice", "orderId", orderId);
      const localVarPath =
        `/api/standardProductOrders/{order_id}/deliveryPrice`.replace(
          `{${"order_id"}}`,
          encodeURIComponent(String(orderId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Determine whether client can see internal notes view
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetInternalNotesVisibility: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/internalNotes/visibility`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * This endpoint retrieves the amount for the monthly payment.
     * @param {PaymentMonthlyPayload} [paymentMonthlyPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetMonthlyPaymentAmount: async (
      paymentMonthlyPayload?: PaymentMonthlyPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/payment/monthly`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        paymentMonthlyPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get option templates from the Gers API
     * @param {OptionTemplateByFilterPayload} [optionTemplateByFilterPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetOptionTemplatesByFilter: async (
      optionTemplateByFilterPayload?: OptionTemplateByFilterPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/optiontemplates/getOptionsByFilter`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        optionTemplateByFilterPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetOrder: async (
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersGetOrder", "orderId", orderId);
      const localVarPath = `/api/orders/{order_id}`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the order`s bumbal data from the gers api
     * @param {string} orderId
     * @param {string} measurementType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetOrderBumbalData: async (
      orderId: string,
      measurementType: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersGetOrderBumbalData", "orderId", orderId);
      // verify required parameter 'measurementType' is not null or undefined
      assertParamExists(
        "gersGetOrderBumbalData",
        "measurementType",
        measurementType,
      );
      const localVarPath = `/api/orders/{order_id}/bumbalData`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (measurementType !== undefined) {
        localVarQueryParameter["measurement_type"] = measurementType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the order`s payment data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetOrderPaymentData: async (
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersGetOrderPaymentData", "orderId", orderId);
      const localVarPath = `/api/orders/{order_id}/paymentData`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * This endpoint retrieves the available payment methods for Betalert.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetPaymentMethods: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/paymentmethods`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get option templates from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetPriceFromOptions: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/optiontemplates/getpricefromoptions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get bumbal before days
     * @param {string} orderId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetStandardProductBumbalBeforeDays: async (
      orderId: string,
      type: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists(
        "gersGetStandardProductBumbalBeforeDays",
        "orderId",
        orderId,
      );
      // verify required parameter 'type' is not null or undefined
      assertParamExists("gersGetStandardProductBumbalBeforeDays", "type", type);
      const localVarPath =
        `/api/StandardOrders/{order_id}/getBumbalBeforeDays`.replace(
          `{${"order_id"}}`,
          encodeURIComponent(String(orderId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter["type"] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get panel categories from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetStandardProductCategories: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/standardProductCategories/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the standard product order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetStandardProductOrder: async (
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersGetStandardProductOrder", "orderId", orderId);
      const localVarPath = `/api/standardorders/{order_id}`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get standard products from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetStandardProducts: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/standardProducts/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the warranty packages from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetWarrantyPackages: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/warrantypackages`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the zakelijk order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetZakelijkOrder: async (
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersGetZakelijkOrder", "orderId", orderId);
      const localVarPath = `/api/orders/{order_id}/getZakelijkOrder`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get option templates from the Gers API
     * @param {OptionTemplatePayload} [optionTemplatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersOptionTemplates: async (
      optionTemplatePayload?: OptionTemplatePayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/optiontemplates`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        optionTemplatePayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Send Bumbal mail for measurement appointment without date
     * @param {string} orderId
     * @param {GersSendBumbalMailMeasurementActivityTypeEnum} activityType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersSendBumbalMailMeasurement: async (
      orderId: string,
      activityType: GersSendBumbalMailMeasurementActivityTypeEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersSendBumbalMailMeasurement", "orderId", orderId);
      // verify required parameter 'activityType' is not null or undefined
      assertParamExists(
        "gersSendBumbalMailMeasurement",
        "activityType",
        activityType,
      );
      const localVarPath = `/api/orders/{order_id}/sendBumbalMail`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (activityType !== undefined) {
        localVarQueryParameter["activityType"] = activityType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Set voucher for the order
     * @param {string} orderId
     * @param {string} [voucherCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersSetOrderVoucher: async (
      orderId: string,
      voucherCode?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersSetOrderVoucher", "orderId", orderId);
      const localVarPath = `/api/orders/{order_id}/setVoucher`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (voucherCode !== undefined) {
        localVarQueryParameter["voucherCode"] = voucherCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Set voucher for a standard order
     * @param {string} orderId
     * @param {string} [voucherCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersSetStandardOrderVoucher: async (
      orderId: string,
      voucherCode?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersSetStandardOrderVoucher", "orderId", orderId);
      const localVarPath = `/api/StandardOrders/{order_id}/setVoucher`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (voucherCode !== undefined) {
        localVarQueryParameter["voucherCode"] = voucherCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get supply products from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersSupplyProducts: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/supplyproducts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update the door product order
     * @param {string} orderId
     * @param {UpdateOrderPayload} [updateOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersUpdateDoorOrder: async (
      orderId: string,
      updateOrderPayload?: UpdateOrderPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersUpdateDoorOrder", "orderId", orderId);
      const localVarPath = `/api/orders/{order_id}`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateOrderPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update the standard product order
     * @param {string} orderId
     * @param {UpdateStandardProductOrderPayload} [updateStandardProductOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersUpdateStandardProductOrder: async (
      orderId: string,
      updateStandardProductOrderPayload?: UpdateStandardProductOrderPayload,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("gersUpdateStandardProductOrder", "orderId", orderId);
      const localVarPath = `/api/standardorders/{order_id}`.replace(
        `{${"order_id"}}`,
        encodeURIComponent(String(orderId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateStandardProductOrderPayload,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Validate discount code on the Gers API
     * @param {string} code
     * @param {string} model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersValidateDiscountCode: async (
      code: string,
      model: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("gersValidateDiscountCode", "code", code);
      // verify required parameter 'model' is not null or undefined
      assertParamExists("gersValidateDiscountCode", "model", model);
      const localVarPath = `/api/discountCodes/validateDiscountCode`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (code !== undefined) {
        localVarQueryParameter["code"] = code;
      }

      if (model !== undefined) {
        localVarQueryParameter["model"] = model;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Validate zipcode on the Gers API
     * @param {string} zipcode
     * @param {string} houseNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersValidateZipCode: async (
      zipcode: string,
      houseNumber: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'zipcode' is not null or undefined
      assertParamExists("gersValidateZipCode", "zipcode", zipcode);
      // verify required parameter 'houseNumber' is not null or undefined
      assertParamExists("gersValidateZipCode", "houseNumber", houseNumber);
      const localVarPath = `/api/orders/validateZipcode`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (zipcode !== undefined) {
        localVarQueryParameter["zipcode"] = zipcode;
      }

      if (houseNumber !== undefined) {
        localVarQueryParameter["houseNumber"] = houseNumber;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get all shop reviews from Trustpilot API for SKU
     * @param {string} sku
     * @param {string} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviews: async (
      sku: string,
      page: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sku' is not null or undefined
      assertParamExists("productReviews", "sku", sku);
      // verify required parameter 'page' is not null or undefined
      assertParamExists("productReviews", "page", page);
      const localVarPath = `/api/reviews/{sku}/{page}`
        .replace(`{${"sku"}}`, encodeURIComponent(String(sku)))
        .replace(`{${"page"}}`, encodeURIComponent(String(page)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get product reviews stats from Trustpilot API
     * @param {string} sku
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewsStats: async (
      sku: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sku' is not null or undefined
      assertParamExists("productReviewsStats", "sku", sku);
      const localVarPath = `/api/reviews/stats/{sku}`.replace(
        `{${"sku"}}`,
        encodeURIComponent(String(sku)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Remove direct discount from an existing order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeDirectDiscount: async (
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("removeDirectDiscount", "orderId", orderId);
      const localVarPath =
        `/api/orders/{order_id}/removeDirectDiscount`.replace(
          `{${"order_id"}}`,
          encodeURIComponent(String(orderId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get all shop reviews from Trustpilot API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shopReviews: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/reviews/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get shop reviews stats from Trustpilot API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shopReviewsStats: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/reviews/stats`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     * Initialize the checkout flow
     * @param {CheckoutPayload} [checkoutPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkout(
      checkoutPayload?: CheckoutPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CheckoutResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkout(
        checkoutPayload,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.checkout"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Generate a payment URL for an existing order
     * @param {string} orderId
     * @param {CreateOrderPaymentPayload} [createOrderPaymentPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createOrderPayment(
      orderId: string,
      createOrderPaymentPayload?: CreateOrderPaymentPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateOrderPaymentResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createOrderPayment(
          orderId,
          createOrderPaymentPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createOrderPayment"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Create a screenshot based on parameters
     * @param {string} door Door code
     * @param {string} layout Layout code
     * @param {string} glass Glass code
     * @param {string} color Color code
     * @param {string} handle Handle code
     * @param {string} webhookUrl Gers endpoint url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createScreenshot(
      door: string,
      layout: string,
      glass: string,
      color: string,
      handle: string,
      webhookUrl: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createScreenshot(
          door,
          layout,
          glass,
          color,
          handle,
          webhookUrl,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createScreenshot"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Generate a payment URL for an existing standard product order
     * @param {string} orderId
     * @param {CreateOrderPaymentPayload} [createOrderPaymentPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createStandardOrderPayment(
      orderId: string,
      createOrderPaymentPayload?: CreateOrderPaymentPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateOrderPaymentResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createStandardOrderPayment(
          orderId,
          createOrderPaymentPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createStandardOrderPayment"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get available Bumbal dates
     * @param {string} orderId
     * @param {string} type
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersAvailableBumbalDates(
      orderId: string,
      type: string,
      dateFrom: string,
      dateTo: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AvailableBumbalDate>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersAvailableBumbalDates(
          orderId,
          type,
          dateFrom,
          dateTo,
          limit,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersAvailableBumbalDates"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get available Standard Order Bumbal dates
     * @param {string} orderId
     * @param {string} type
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersAvailableStandardOrderBumbalDates(
      orderId: string,
      type: string,
      dateFrom: string,
      dateTo: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AvailableBumbalDate>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersAvailableStandardOrderBumbalDates(
          orderId,
          type,
          dateFrom,
          dateTo,
          limit,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.gersAvailableStandardOrderBumbalDates"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Check if ip in call is from a sale location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersCheckSaleLocation(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CheckSaleLocationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersCheckSaleLocation(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersCheckSaleLocation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Create Bumbal date
     * @param {string} orderId
     * @param {CreateBumbalDatePayload} [createBumbalDatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersCreateBumbalDate(
      orderId: string,
      createBumbalDatePayload?: CreateBumbalDatePayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersCreateBumbalDate(
          orderId,
          createBumbalDatePayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersCreateBumbalDate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Create a cart on the Gers API
     * @param {CreateCartPayload} [createCartPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersCreateCart(
      createCartPayload?: CreateCartPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateCartResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gersCreateCart(
        createCartPayload,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersCreateCart"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Create order on the Gers API
     * @param {CreateOrderPayload} [createOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersCreateOrder(
      createOrderPayload?: CreateOrderPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateOrderResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gersCreateOrder(
        createOrderPayload,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersCreateOrder"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Create payment link for orders
     * @param {string} orderId
     * @param {CreateOrderPaymentLinkPayload} [createOrderPaymentLinkPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersCreateOrderPaymentLink(
      orderId: string,
      createOrderPaymentLinkPayload?: CreateOrderPaymentLinkPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateOrderPaymentResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersCreateOrderPaymentLink(
          orderId,
          createOrderPaymentLinkPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersCreateOrderPaymentLink"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Assign a warranty to an order
     * @param {CreateOrderWarrantyPayload} [createOrderWarrantyPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersCreateOrderWarranty(
      createOrderWarrantyPayload?: CreateOrderWarrantyPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateOrderWarrantyResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersCreateOrderWarranty(
          createOrderWarrantyPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersCreateOrderWarranty"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Create Bumbal date
     * @param {string} orderId
     * @param {CreateBumbalDatePayload} [createBumbalDatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersCreateStandardProductOrderBumbalDate(
      orderId: string,
      createBumbalDatePayload?: CreateBumbalDatePayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersCreateStandardProductOrderBumbalDate(
          orderId,
          createBumbalDatePayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.gersCreateStandardProductOrderBumbalDate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Create payment link for standard orders
     * @param {string} orderId
     * @param {CreateStandardOrderPaymentLinkPayload} [createStandardOrderPaymentLinkPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersCreateStandardProductOrderPaymentLink(
      orderId: string,
      createStandardOrderPaymentLinkPayload?: CreateStandardOrderPaymentLinkPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateOrderPaymentResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersCreateStandardProductOrderPaymentLink(
          orderId,
          createStandardOrderPaymentLinkPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.gersCreateStandardProductOrderPaymentLink"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersDeleteOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gersDeleteOrder(
        orderId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersDeleteOrder"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Delete a standard product order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersDeleteStandardOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersDeleteStandardOrder(
          orderId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersDeleteStandardOrder"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get discount codes from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersDiscountCodes(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersDiscountCodes(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersDiscountCodes"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Generate an Icepay payment link
     * @param {string} data
     * @param {string} method
     * @param {string} issuer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGenerateIcepayLink(
      data: string,
      method: string,
      issuer: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IcepayResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGenerateIcepayLink(
          data,
          method,
          issuer,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGenerateIcepayLink"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the cart data from the gers api
     * @param {string} cartId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetCart(
      cartId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetCartResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gersGetCart(
        cartId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetCart"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get dealer discounts by KVK number
     * @param {string} kvk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetDealerDiscountsByKVK(
      kvk: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DealerDiscount>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetDealerDiscountsByKVK(
          kvk,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetDealerDiscountsByKVK"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the delivery price for the standard product order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetDeliveryPrice(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetDeliveryPriceResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetDeliveryPrice(orderId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetDeliveryPrice"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Determine whether client can see internal notes view
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetInternalNotesVisibility(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<InternalNotesVisibilityResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetInternalNotesVisibility(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetInternalNotesVisibility"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * This endpoint retrieves the amount for the monthly payment.
     * @param {PaymentMonthlyPayload} [paymentMonthlyPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetMonthlyPaymentAmount(
      paymentMonthlyPayload?: PaymentMonthlyPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaymentMonthlyResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetMonthlyPaymentAmount(
          paymentMonthlyPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetMonthlyPaymentAmount"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get option templates from the Gers API
     * @param {OptionTemplateByFilterPayload} [optionTemplateByFilterPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetOptionTemplatesByFilter(
      optionTemplateByFilterPayload?: OptionTemplateByFilterPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OptionTemplatesByFilterResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetOptionTemplatesByFilter(
          optionTemplateByFilterPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetOptionTemplatesByFilter"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetOrderResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gersGetOrder(
        orderId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetOrder"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the order`s bumbal data from the gers api
     * @param {string} orderId
     * @param {string} measurementType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetOrderBumbalData(
      orderId: string,
      measurementType: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetOrderBumbalDataResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetOrderBumbalData(
          orderId,
          measurementType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetOrderBumbalData"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the order`s payment data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetOrderPaymentData(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetOrderPaymentDataResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetOrderPaymentData(
          orderId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetOrderPaymentData"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * This endpoint retrieves the available payment methods for Betalert.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetPaymentMethods(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PaymentMethod>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetPaymentMethods(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetPaymentMethods"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get option templates from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetPriceFromOptions(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Price>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetPriceFromOptions(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetPriceFromOptions"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get bumbal before days
     * @param {string} orderId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetStandardProductBumbalBeforeDays(
      orderId: string,
      type: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetBumbalBeforeDaysResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetStandardProductBumbalBeforeDays(
          orderId,
          type,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.gersGetStandardProductBumbalBeforeDays"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get panel categories from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetStandardProductCategories(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<StandardProductCategory>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetStandardProductCategories(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetStandardProductCategories"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the standard product order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetStandardProductOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetStandardProductOrderResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetStandardProductOrder(
          orderId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetStandardProductOrder"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get standard products from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetStandardProducts(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<StandardProduct>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetStandardProducts(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetStandardProducts"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the warranty packages from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetWarrantyPackages(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WarrantyPackagesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetWarrantyPackages(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetWarrantyPackages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get the zakelijk order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersGetZakelijkOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetZakelijkOrderResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersGetZakelijkOrder(orderId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersGetZakelijkOrder"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get option templates from the Gers API
     * @param {OptionTemplatePayload} [optionTemplatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersOptionTemplates(
      optionTemplatePayload?: OptionTemplatePayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OptionTemplate>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersOptionTemplates(
          optionTemplatePayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersOptionTemplates"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Send Bumbal mail for measurement appointment without date
     * @param {string} orderId
     * @param {GersSendBumbalMailMeasurementActivityTypeEnum} activityType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersSendBumbalMailMeasurement(
      orderId: string,
      activityType: GersSendBumbalMailMeasurementActivityTypeEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersSendBumbalMailMeasurement(
          orderId,
          activityType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersSendBumbalMailMeasurement"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Set voucher for the order
     * @param {string} orderId
     * @param {string} [voucherCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersSetOrderVoucher(
      orderId: string,
      voucherCode?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersSetOrderVoucher(
          orderId,
          voucherCode,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersSetOrderVoucher"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Set voucher for a standard order
     * @param {string} orderId
     * @param {string} [voucherCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersSetStandardOrderVoucher(
      orderId: string,
      voucherCode?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersSetStandardOrderVoucher(
          orderId,
          voucherCode,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersSetStandardOrderVoucher"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get supply products from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersSupplyProducts(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<SupplyProduct>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersSupplyProducts(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersSupplyProducts"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Update the door product order
     * @param {string} orderId
     * @param {UpdateOrderPayload} [updateOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersUpdateDoorOrder(
      orderId: string,
      updateOrderPayload?: UpdateOrderPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersUpdateDoorOrder(
          orderId,
          updateOrderPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersUpdateDoorOrder"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Update the standard product order
     * @param {string} orderId
     * @param {UpdateStandardProductOrderPayload} [updateStandardProductOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersUpdateStandardProductOrder(
      orderId: string,
      updateStandardProductOrderPayload?: UpdateStandardProductOrderPayload,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersUpdateStandardProductOrder(
          orderId,
          updateStandardProductOrderPayload,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersUpdateStandardProductOrder"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Validate discount code on the Gers API
     * @param {string} code
     * @param {string} model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersValidateDiscountCode(
      code: string,
      model: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ValidateDiscountCodeResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersValidateDiscountCode(
          code,
          model,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersValidateDiscountCode"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Validate zipcode on the Gers API
     * @param {string} zipcode
     * @param {string} houseNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gersValidateZipCode(
      zipcode: string,
      houseNumber: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ValidateZipcodeResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.gersValidateZipCode(
          zipcode,
          houseNumber,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.gersValidateZipCode"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get all shop reviews from Trustpilot API for SKU
     * @param {string} sku
     * @param {string} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productReviews(
      sku: string,
      page: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ProductReview>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productReviews(
        sku,
        page,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.productReviews"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get product reviews stats from Trustpilot API
     * @param {string} sku
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productReviewsStats(
      sku: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ProductReviewsStatsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.productReviewsStats(sku, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.productReviewsStats"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Remove direct discount from an existing order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeDirectDiscount(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RemoveOrderDirectDiscountResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.removeDirectDiscount(orderId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.removeDirectDiscount"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get all shop reviews from Trustpilot API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async shopReviews(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Review>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.shopReviews(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.shopReviews"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get shop reviews stats from Trustpilot API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async shopReviewsStats(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ReviewsStatsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.shopReviewsStats(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.shopReviewsStats"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     * Initialize the checkout flow
     * @param {CheckoutPayload} [checkoutPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkout(
      checkoutPayload?: CheckoutPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CheckoutResponse> {
      return localVarFp
        .checkout(checkoutPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Generate a payment URL for an existing order
     * @param {string} orderId
     * @param {CreateOrderPaymentPayload} [createOrderPaymentPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrderPayment(
      orderId: string,
      createOrderPaymentPayload?: CreateOrderPaymentPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderPaymentResponse> {
      return localVarFp
        .createOrderPayment(orderId, createOrderPaymentPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create a screenshot based on parameters
     * @param {string} door Door code
     * @param {string} layout Layout code
     * @param {string} glass Glass code
     * @param {string} color Color code
     * @param {string} handle Handle code
     * @param {string} webhookUrl Gers endpoint url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createScreenshot(
      door: string,
      layout: string,
      glass: string,
      color: string,
      handle: string,
      webhookUrl: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .createScreenshot(
          door,
          layout,
          glass,
          color,
          handle,
          webhookUrl,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Generate a payment URL for an existing standard product order
     * @param {string} orderId
     * @param {CreateOrderPaymentPayload} [createOrderPaymentPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStandardOrderPayment(
      orderId: string,
      createOrderPaymentPayload?: CreateOrderPaymentPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderPaymentResponse> {
      return localVarFp
        .createStandardOrderPayment(orderId, createOrderPaymentPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get available Bumbal dates
     * @param {string} orderId
     * @param {string} type
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersAvailableBumbalDates(
      orderId: string,
      type: string,
      dateFrom: string,
      dateTo: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<AvailableBumbalDate>> {
      return localVarFp
        .gersAvailableBumbalDates(
          orderId,
          type,
          dateFrom,
          dateTo,
          limit,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Get available Standard Order Bumbal dates
     * @param {string} orderId
     * @param {string} type
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersAvailableStandardOrderBumbalDates(
      orderId: string,
      type: string,
      dateFrom: string,
      dateTo: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<AvailableBumbalDate>> {
      return localVarFp
        .gersAvailableStandardOrderBumbalDates(
          orderId,
          type,
          dateFrom,
          dateTo,
          limit,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Check if ip in call is from a sale location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCheckSaleLocation(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CheckSaleLocationResponse> {
      return localVarFp
        .gersCheckSaleLocation(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create Bumbal date
     * @param {string} orderId
     * @param {CreateBumbalDatePayload} [createBumbalDatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateBumbalDate(
      orderId: string,
      createBumbalDatePayload?: CreateBumbalDatePayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersCreateBumbalDate(orderId, createBumbalDatePayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create a cart on the Gers API
     * @param {CreateCartPayload} [createCartPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateCart(
      createCartPayload?: CreateCartPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateCartResponse> {
      return localVarFp
        .gersCreateCart(createCartPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create order on the Gers API
     * @param {CreateOrderPayload} [createOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateOrder(
      createOrderPayload?: CreateOrderPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderResponse> {
      return localVarFp
        .gersCreateOrder(createOrderPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create payment link for orders
     * @param {string} orderId
     * @param {CreateOrderPaymentLinkPayload} [createOrderPaymentLinkPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateOrderPaymentLink(
      orderId: string,
      createOrderPaymentLinkPayload?: CreateOrderPaymentLinkPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderPaymentResponse> {
      return localVarFp
        .gersCreateOrderPaymentLink(
          orderId,
          createOrderPaymentLinkPayload,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Assign a warranty to an order
     * @param {CreateOrderWarrantyPayload} [createOrderWarrantyPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateOrderWarranty(
      createOrderWarrantyPayload?: CreateOrderWarrantyPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderWarrantyResponse> {
      return localVarFp
        .gersCreateOrderWarranty(createOrderWarrantyPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Create Bumbal date
     * @param {string} orderId
     * @param {CreateBumbalDatePayload} [createBumbalDatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateStandardProductOrderBumbalDate(
      orderId: string,
      createBumbalDatePayload?: CreateBumbalDatePayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersCreateStandardProductOrderBumbalDate(
          orderId,
          createBumbalDatePayload,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Create payment link for standard orders
     * @param {string} orderId
     * @param {CreateStandardOrderPaymentLinkPayload} [createStandardOrderPaymentLinkPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersCreateStandardProductOrderPaymentLink(
      orderId: string,
      createStandardOrderPaymentLinkPayload?: CreateStandardOrderPaymentLinkPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderPaymentResponse> {
      return localVarFp
        .gersCreateStandardProductOrderPaymentLink(
          orderId,
          createStandardOrderPaymentLinkPayload,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersDeleteOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersDeleteOrder(orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Delete a standard product order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersDeleteStandardOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersDeleteStandardOrder(orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get discount codes from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersDiscountCodes(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .gersDiscountCodes(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Generate an Icepay payment link
     * @param {string} data
     * @param {string} method
     * @param {string} issuer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGenerateIcepayLink(
      data: string,
      method: string,
      issuer: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<IcepayResponse> {
      return localVarFp
        .gersGenerateIcepayLink(data, method, issuer, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the cart data from the gers api
     * @param {string} cartId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetCart(
      cartId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetCartResponse> {
      return localVarFp
        .gersGetCart(cartId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get dealer discounts by KVK number
     * @param {string} kvk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetDealerDiscountsByKVK(
      kvk: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<DealerDiscount>> {
      return localVarFp
        .gersGetDealerDiscountsByKVK(kvk, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the delivery price for the standard product order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetDeliveryPrice(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetDeliveryPriceResponse> {
      return localVarFp
        .gersGetDeliveryPrice(orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Determine whether client can see internal notes view
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetInternalNotesVisibility(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InternalNotesVisibilityResponse> {
      return localVarFp
        .gersGetInternalNotesVisibility(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This endpoint retrieves the amount for the monthly payment.
     * @param {PaymentMonthlyPayload} [paymentMonthlyPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetMonthlyPaymentAmount(
      paymentMonthlyPayload?: PaymentMonthlyPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaymentMonthlyResponse> {
      return localVarFp
        .gersGetMonthlyPaymentAmount(paymentMonthlyPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get option templates from the Gers API
     * @param {OptionTemplateByFilterPayload} [optionTemplateByFilterPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetOptionTemplatesByFilter(
      optionTemplateByFilterPayload?: OptionTemplateByFilterPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OptionTemplatesByFilterResponse> {
      return localVarFp
        .gersGetOptionTemplatesByFilter(optionTemplateByFilterPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetOrderResponse> {
      return localVarFp
        .gersGetOrder(orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the order`s bumbal data from the gers api
     * @param {string} orderId
     * @param {string} measurementType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetOrderBumbalData(
      orderId: string,
      measurementType: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetOrderBumbalDataResponse> {
      return localVarFp
        .gersGetOrderBumbalData(orderId, measurementType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the order`s payment data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetOrderPaymentData(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetOrderPaymentDataResponse> {
      return localVarFp
        .gersGetOrderPaymentData(orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This endpoint retrieves the available payment methods for Betalert.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetPaymentMethods(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PaymentMethod>> {
      return localVarFp
        .gersGetPaymentMethods(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get option templates from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetPriceFromOptions(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Price> {
      return localVarFp
        .gersGetPriceFromOptions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get bumbal before days
     * @param {string} orderId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetStandardProductBumbalBeforeDays(
      orderId: string,
      type: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetBumbalBeforeDaysResponse> {
      return localVarFp
        .gersGetStandardProductBumbalBeforeDays(orderId, type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get panel categories from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetStandardProductCategories(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<StandardProductCategory>> {
      return localVarFp
        .gersGetStandardProductCategories(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the standard product order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetStandardProductOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetStandardProductOrderResponse> {
      return localVarFp
        .gersGetStandardProductOrder(orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get standard products from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetStandardProducts(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<StandardProduct>> {
      return localVarFp
        .gersGetStandardProducts(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the warranty packages from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetWarrantyPackages(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WarrantyPackagesResponse> {
      return localVarFp
        .gersGetWarrantyPackages(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get the zakelijk order data from the gers api
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersGetZakelijkOrder(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetZakelijkOrderResponse> {
      return localVarFp
        .gersGetZakelijkOrder(orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get option templates from the Gers API
     * @param {OptionTemplatePayload} [optionTemplatePayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersOptionTemplates(
      optionTemplatePayload?: OptionTemplatePayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<OptionTemplate>> {
      return localVarFp
        .gersOptionTemplates(optionTemplatePayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Send Bumbal mail for measurement appointment without date
     * @param {string} orderId
     * @param {GersSendBumbalMailMeasurementActivityTypeEnum} activityType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersSendBumbalMailMeasurement(
      orderId: string,
      activityType: GersSendBumbalMailMeasurementActivityTypeEnum,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersSendBumbalMailMeasurement(orderId, activityType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Set voucher for the order
     * @param {string} orderId
     * @param {string} [voucherCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersSetOrderVoucher(
      orderId: string,
      voucherCode?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersSetOrderVoucher(orderId, voucherCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Set voucher for a standard order
     * @param {string} orderId
     * @param {string} [voucherCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersSetStandardOrderVoucher(
      orderId: string,
      voucherCode?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersSetStandardOrderVoucher(orderId, voucherCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get supply products from the Gers API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersSupplyProducts(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SupplyProduct>> {
      return localVarFp
        .gersSupplyProducts(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update the door product order
     * @param {string} orderId
     * @param {UpdateOrderPayload} [updateOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersUpdateDoorOrder(
      orderId: string,
      updateOrderPayload?: UpdateOrderPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersUpdateDoorOrder(orderId, updateOrderPayload, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update the standard product order
     * @param {string} orderId
     * @param {UpdateStandardProductOrderPayload} [updateStandardProductOrderPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersUpdateStandardProductOrder(
      orderId: string,
      updateStandardProductOrderPayload?: UpdateStandardProductOrderPayload,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .gersUpdateStandardProductOrder(
          orderId,
          updateStandardProductOrderPayload,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Validate discount code on the Gers API
     * @param {string} code
     * @param {string} model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersValidateDiscountCode(
      code: string,
      model: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ValidateDiscountCodeResponse> {
      return localVarFp
        .gersValidateDiscountCode(code, model, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Validate zipcode on the Gers API
     * @param {string} zipcode
     * @param {string} houseNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gersValidateZipCode(
      zipcode: string,
      houseNumber: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ValidateZipcodeResponse> {
      return localVarFp
        .gersValidateZipCode(zipcode, houseNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get all shop reviews from Trustpilot API for SKU
     * @param {string} sku
     * @param {string} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviews(
      sku: string,
      page: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ProductReview>> {
      return localVarFp
        .productReviews(sku, page, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get product reviews stats from Trustpilot API
     * @param {string} sku
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productReviewsStats(
      sku: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ProductReviewsStatsResponse> {
      return localVarFp
        .productReviewsStats(sku, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Remove direct discount from an existing order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeDirectDiscount(
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RemoveOrderDirectDiscountResponse> {
      return localVarFp
        .removeDirectDiscount(orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get all shop reviews from Trustpilot API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shopReviews(options?: RawAxiosRequestConfig): AxiosPromise<Array<Review>> {
      return localVarFp
        .shopReviews(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get shop reviews stats from Trustpilot API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shopReviewsStats(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ReviewsStatsResponse> {
      return localVarFp
        .shopReviewsStats(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   * Initialize the checkout flow
   * @param {CheckoutPayload} [checkoutPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public checkout(
    checkoutPayload?: CheckoutPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .checkout(checkoutPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Generate a payment URL for an existing order
   * @param {string} orderId
   * @param {CreateOrderPaymentPayload} [createOrderPaymentPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createOrderPayment(
    orderId: string,
    createOrderPaymentPayload?: CreateOrderPaymentPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createOrderPayment(orderId, createOrderPaymentPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create a screenshot based on parameters
   * @param {string} door Door code
   * @param {string} layout Layout code
   * @param {string} glass Glass code
   * @param {string} color Color code
   * @param {string} handle Handle code
   * @param {string} webhookUrl Gers endpoint url
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createScreenshot(
    door: string,
    layout: string,
    glass: string,
    color: string,
    handle: string,
    webhookUrl: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createScreenshot(door, layout, glass, color, handle, webhookUrl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Generate a payment URL for an existing standard product order
   * @param {string} orderId
   * @param {CreateOrderPaymentPayload} [createOrderPaymentPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createStandardOrderPayment(
    orderId: string,
    createOrderPaymentPayload?: CreateOrderPaymentPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createStandardOrderPayment(orderId, createOrderPaymentPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get available Bumbal dates
   * @param {string} orderId
   * @param {string} type
   * @param {string} dateFrom
   * @param {string} dateTo
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersAvailableBumbalDates(
    orderId: string,
    type: string,
    dateFrom: string,
    dateTo: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersAvailableBumbalDates(orderId, type, dateFrom, dateTo, limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get available Standard Order Bumbal dates
   * @param {string} orderId
   * @param {string} type
   * @param {string} dateFrom
   * @param {string} dateTo
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersAvailableStandardOrderBumbalDates(
    orderId: string,
    type: string,
    dateFrom: string,
    dateTo: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersAvailableStandardOrderBumbalDates(
        orderId,
        type,
        dateFrom,
        dateTo,
        limit,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Check if ip in call is from a sale location
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersCheckSaleLocation(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersCheckSaleLocation(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create Bumbal date
   * @param {string} orderId
   * @param {CreateBumbalDatePayload} [createBumbalDatePayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersCreateBumbalDate(
    orderId: string,
    createBumbalDatePayload?: CreateBumbalDatePayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersCreateBumbalDate(orderId, createBumbalDatePayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create a cart on the Gers API
   * @param {CreateCartPayload} [createCartPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersCreateCart(
    createCartPayload?: CreateCartPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersCreateCart(createCartPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create order on the Gers API
   * @param {CreateOrderPayload} [createOrderPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersCreateOrder(
    createOrderPayload?: CreateOrderPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersCreateOrder(createOrderPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create payment link for orders
   * @param {string} orderId
   * @param {CreateOrderPaymentLinkPayload} [createOrderPaymentLinkPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersCreateOrderPaymentLink(
    orderId: string,
    createOrderPaymentLinkPayload?: CreateOrderPaymentLinkPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersCreateOrderPaymentLink(
        orderId,
        createOrderPaymentLinkPayload,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Assign a warranty to an order
   * @param {CreateOrderWarrantyPayload} [createOrderWarrantyPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersCreateOrderWarranty(
    createOrderWarrantyPayload?: CreateOrderWarrantyPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersCreateOrderWarranty(createOrderWarrantyPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create Bumbal date
   * @param {string} orderId
   * @param {CreateBumbalDatePayload} [createBumbalDatePayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersCreateStandardProductOrderBumbalDate(
    orderId: string,
    createBumbalDatePayload?: CreateBumbalDatePayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersCreateStandardProductOrderBumbalDate(
        orderId,
        createBumbalDatePayload,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Create payment link for standard orders
   * @param {string} orderId
   * @param {CreateStandardOrderPaymentLinkPayload} [createStandardOrderPaymentLinkPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersCreateStandardProductOrderPaymentLink(
    orderId: string,
    createStandardOrderPaymentLinkPayload?: CreateStandardOrderPaymentLinkPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersCreateStandardProductOrderPaymentLink(
        orderId,
        createStandardOrderPaymentLinkPayload,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the order data from the gers api
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersDeleteOrder(orderId: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersDeleteOrder(orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Delete a standard product order
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersDeleteStandardOrder(
    orderId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersDeleteStandardOrder(orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get discount codes from the Gers API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersDiscountCodes(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersDiscountCodes(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Generate an Icepay payment link
   * @param {string} data
   * @param {string} method
   * @param {string} issuer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGenerateIcepayLink(
    data: string,
    method: string,
    issuer: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGenerateIcepayLink(data, method, issuer, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the cart data from the gers api
   * @param {string} cartId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetCart(cartId: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersGetCart(cartId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get dealer discounts by KVK number
   * @param {string} kvk
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetDealerDiscountsByKVK(
    kvk: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetDealerDiscountsByKVK(kvk, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the delivery price for the standard product order data from the gers api
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetDeliveryPrice(
    orderId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetDeliveryPrice(orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Determine whether client can see internal notes view
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetInternalNotesVisibility(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersGetInternalNotesVisibility(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * This endpoint retrieves the amount for the monthly payment.
   * @param {PaymentMonthlyPayload} [paymentMonthlyPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetMonthlyPaymentAmount(
    paymentMonthlyPayload?: PaymentMonthlyPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetMonthlyPaymentAmount(paymentMonthlyPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get option templates from the Gers API
   * @param {OptionTemplateByFilterPayload} [optionTemplateByFilterPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetOptionTemplatesByFilter(
    optionTemplateByFilterPayload?: OptionTemplateByFilterPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetOptionTemplatesByFilter(optionTemplateByFilterPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the order data from the gers api
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetOrder(orderId: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersGetOrder(orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the order`s bumbal data from the gers api
   * @param {string} orderId
   * @param {string} measurementType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetOrderBumbalData(
    orderId: string,
    measurementType: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetOrderBumbalData(orderId, measurementType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the order`s payment data from the gers api
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetOrderPaymentData(
    orderId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetOrderPaymentData(orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * This endpoint retrieves the available payment methods for Betalert.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetPaymentMethods(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersGetPaymentMethods(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get option templates from the Gers API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetPriceFromOptions(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersGetPriceFromOptions(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get bumbal before days
   * @param {string} orderId
   * @param {string} type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetStandardProductBumbalBeforeDays(
    orderId: string,
    type: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetStandardProductBumbalBeforeDays(orderId, type, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get panel categories from the Gers API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetStandardProductCategories(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersGetStandardProductCategories(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the standard product order data from the gers api
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetStandardProductOrder(
    orderId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetStandardProductOrder(orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get standard products from the Gers API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetStandardProducts(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersGetStandardProducts(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the warranty packages from the Gers API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetWarrantyPackages(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersGetWarrantyPackages(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get the zakelijk order data from the gers api
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersGetZakelijkOrder(
    orderId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersGetZakelijkOrder(orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get option templates from the Gers API
   * @param {OptionTemplatePayload} [optionTemplatePayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersOptionTemplates(
    optionTemplatePayload?: OptionTemplatePayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersOptionTemplates(optionTemplatePayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Send Bumbal mail for measurement appointment without date
   * @param {string} orderId
   * @param {GersSendBumbalMailMeasurementActivityTypeEnum} activityType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersSendBumbalMailMeasurement(
    orderId: string,
    activityType: GersSendBumbalMailMeasurementActivityTypeEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersSendBumbalMailMeasurement(orderId, activityType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Set voucher for the order
   * @param {string} orderId
   * @param {string} [voucherCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersSetOrderVoucher(
    orderId: string,
    voucherCode?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersSetOrderVoucher(orderId, voucherCode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Set voucher for a standard order
   * @param {string} orderId
   * @param {string} [voucherCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersSetStandardOrderVoucher(
    orderId: string,
    voucherCode?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersSetStandardOrderVoucher(orderId, voucherCode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get supply products from the Gers API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersSupplyProducts(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .gersSupplyProducts(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Update the door product order
   * @param {string} orderId
   * @param {UpdateOrderPayload} [updateOrderPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersUpdateDoorOrder(
    orderId: string,
    updateOrderPayload?: UpdateOrderPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersUpdateDoorOrder(orderId, updateOrderPayload, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Update the standard product order
   * @param {string} orderId
   * @param {UpdateStandardProductOrderPayload} [updateStandardProductOrderPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersUpdateStandardProductOrder(
    orderId: string,
    updateStandardProductOrderPayload?: UpdateStandardProductOrderPayload,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersUpdateStandardProductOrder(
        orderId,
        updateStandardProductOrderPayload,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Validate discount code on the Gers API
   * @param {string} code
   * @param {string} model
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersValidateDiscountCode(
    code: string,
    model: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersValidateDiscountCode(code, model, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Validate zipcode on the Gers API
   * @param {string} zipcode
   * @param {string} houseNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public gersValidateZipCode(
    zipcode: string,
    houseNumber: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .gersValidateZipCode(zipcode, houseNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get all shop reviews from Trustpilot API for SKU
   * @param {string} sku
   * @param {string} page
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public productReviews(
    sku: string,
    page: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .productReviews(sku, page, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get product reviews stats from Trustpilot API
   * @param {string} sku
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public productReviewsStats(sku: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .productReviewsStats(sku, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Remove direct discount from an existing order
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public removeDirectDiscount(
    orderId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .removeDirectDiscount(orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get all shop reviews from Trustpilot API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public shopReviews(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .shopReviews(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get shop reviews stats from Trustpilot API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public shopReviewsStats(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .shopReviewsStats(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GersSendBumbalMailMeasurementActivityTypeEnum = {
  Measurement: "measurement",
} as const;
export type GersSendBumbalMailMeasurementActivityTypeEnum =
  (typeof GersSendBumbalMailMeasurementActivityTypeEnum)[keyof typeof GersSendBumbalMailMeasurementActivityTypeEnum];
